!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("@walletconnect/web3-subprovider", [], e) : "object" == typeof exports ? exports["@walletconnect/web3-subprovider"] = e() : t["@walletconnect/web3-subprovider"] = e();
}(window, function () {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        r.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 1);
  }([function (t, e, r) {
    "use strict";

    r.r(e), r.d(e, "__extends", function () {
      return o;
    }), r.d(e, "__assign", function () {
      return _i;
    }), r.d(e, "__rest", function () {
      return u;
    }), r.d(e, "__decorate", function () {
      return a;
    }), r.d(e, "__param", function () {
      return s;
    }), r.d(e, "__metadata", function () {
      return f;
    }), r.d(e, "__awaiter", function () {
      return c;
    }), r.d(e, "__generator", function () {
      return h;
    }), r.d(e, "__exportStar", function () {
      return l;
    }), r.d(e, "__values", function () {
      return p;
    }), r.d(e, "__read", function () {
      return d;
    }), r.d(e, "__spread", function () {
      return y;
    }), r.d(e, "__await", function () {
      return g;
    }), r.d(e, "__asyncGenerator", function () {
      return v;
    }), r.d(e, "__asyncDelegator", function () {
      return _;
    }), r.d(e, "__asyncValues", function () {
      return w;
    }), r.d(e, "__makeTemplateObject", function () {
      return b;
    }), r.d(e, "__importStar", function () {
      return m;
    }), r.d(e, "__importDefault", function () {
      return S;
    });
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0
    
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.
    
    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var _n = function n(t, e) {
      return (_n = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var r in e) {
          e.hasOwnProperty(r) && (t[r] = e[r]);
        }
      })(t, e);
    };

    function o(t, e) {
      function r() {
        this.constructor = t;
      }

      _n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
    }

    var _i = function i() {
      return (_i = Object.assign || function (t) {
        for (var e, r = 1, n = arguments.length; r < n; r++) {
          for (var o in e = arguments[r]) {
            Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
          }
        }

        return t;
      }).apply(this, arguments);
    };

    function u(t, e) {
      var r = {};

      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
      }

      if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) {
          e.indexOf(n[o]) < 0 && (r[n[o]] = t[n[o]]);
        }
      }

      return r;
    }

    function a(t, e, r, n) {
      var o,
          i = arguments.length,
          u = i < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) u = Reflect.decorate(t, e, r, n);else for (var a = t.length - 1; a >= 0; a--) {
        (o = t[a]) && (u = (i < 3 ? o(u) : i > 3 ? o(e, r, u) : o(e, r)) || u);
      }
      return i > 3 && u && Object.defineProperty(e, r, u), u;
    }

    function s(t, e) {
      return function (r, n) {
        e(r, n, t);
      };
    }

    function f(t, e) {
      if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
    }

    function c(t, e, r, n) {
      return new (r || (r = Promise))(function (o, i) {
        function u(t) {
          try {
            s(n.next(t));
          } catch (t) {
            i(t);
          }
        }

        function a(t) {
          try {
            s(n.throw(t));
          } catch (t) {
            i(t);
          }
        }

        function s(t) {
          t.done ? o(t.value) : new r(function (e) {
            e(t.value);
          }).then(u, a);
        }

        s((n = n.apply(t, e || [])).next());
      });
    }

    function h(t, e) {
      var r,
          n,
          o,
          i,
          u = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: a(0),
        throw: a(1),
        return: a(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function a(i) {
        return function (a) {
          return function (i) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; u;) {
              try {
                if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return u.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    u.label++, n = i[1], i = [0];
                    continue;

                  case 7:
                    i = u.ops.pop(), u.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = u.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      u = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      u.label = i[1];
                      break;
                    }

                    if (6 === i[0] && u.label < o[1]) {
                      u.label = o[1], o = i;
                      break;
                    }

                    if (o && u.label < o[2]) {
                      u.label = o[2], u.ops.push(i);
                      break;
                    }

                    o[2] && u.ops.pop(), u.trys.pop();
                    continue;
                }

                i = e.call(t, u);
              } catch (t) {
                i = [6, t], n = 0;
              } finally {
                r = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, a]);
        };
      }
    }

    function l(t, e) {
      for (var r in t) {
        e.hasOwnProperty(r) || (e[r] = t[r]);
      }
    }

    function p(t) {
      var e = "function" == typeof Symbol && t[Symbol.iterator],
          r = 0;
      return e ? e.call(t) : {
        next: function next() {
          return t && r >= t.length && (t = void 0), {
            value: t && t[r++],
            done: !t
          };
        }
      };
    }

    function d(t, e) {
      var r = "function" == typeof Symbol && t[Symbol.iterator];
      if (!r) return t;
      var n,
          o,
          i = r.call(t),
          u = [];

      try {
        for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) {
          u.push(n.value);
        }
      } catch (t) {
        o = {
          error: t
        };
      } finally {
        try {
          n && !n.done && (r = i.return) && r.call(i);
        } finally {
          if (o) throw o.error;
        }
      }

      return u;
    }

    function y() {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t = t.concat(d(arguments[e]));
      }

      return t;
    }

    function g(t) {
      return this instanceof g ? (this.v = t, this) : new g(t);
    }

    function v(t, e, r) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var n,
          o = r.apply(t, e || []),
          i = [];
      return n = {}, u("next"), u("throw"), u("return"), n[Symbol.asyncIterator] = function () {
        return this;
      }, n;

      function u(t) {
        o[t] && (n[t] = function (e) {
          return new Promise(function (r, n) {
            i.push([t, e, r, n]) > 1 || a(t, e);
          });
        });
      }

      function a(t, e) {
        try {
          (r = o[t](e)).value instanceof g ? Promise.resolve(r.value.v).then(s, f) : c(i[0][2], r);
        } catch (t) {
          c(i[0][3], t);
        }

        var r;
      }

      function s(t) {
        a("next", t);
      }

      function f(t) {
        a("throw", t);
      }

      function c(t, e) {
        t(e), i.shift(), i.length && a(i[0][0], i[0][1]);
      }
    }

    function _(t) {
      var e, r;
      return e = {}, n("next"), n("throw", function (t) {
        throw t;
      }), n("return"), e[Symbol.iterator] = function () {
        return this;
      }, e;

      function n(n, o) {
        e[n] = t[n] ? function (e) {
          return (r = !r) ? {
            value: g(t[n](e)),
            done: "return" === n
          } : o ? o(e) : e;
        } : o;
      }
    }

    function w(t) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var e,
          r = t[Symbol.asyncIterator];
      return r ? r.call(t) : (t = p(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
        return this;
      }, e);

      function n(r) {
        e[r] = t[r] && function (e) {
          return new Promise(function (n, o) {
            (function (t, e, r, n) {
              Promise.resolve(n).then(function (e) {
                t({
                  value: e,
                  done: r
                });
              }, e);
            })(n, o, (e = t[r](e)).done, e.value);
          });
        };
      }
    }

    function b(t, e) {
      return Object.defineProperty ? Object.defineProperty(t, "raw", {
        value: e
      }) : t.raw = e, t;
    }

    function m(t) {
      if (t && t.__esModule) return t;
      var e = {};
      if (null != t) for (var r in t) {
        Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
      return e.default = t, e;
    }

    function S(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var n = r(0),
        o = n.__importDefault(r(2)),
        i = function (t) {
      function e(e) {
        var r = t.call(this) || this;
        return r._walletConnector = new o.default(e), r;
      }

      return n.__extends(e, t), Object.defineProperty(e.prototype, "isWalletConnect", {
        get: function get() {
          return !0;
        },
        set: function set(t) {},
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "connected", {
        get: function get() {
          return this._walletConnector.connected;
        },
        set: function set(t) {},
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "uri", {
        get: function get() {
          return this._walletConnector.uri;
        },
        set: function set(t) {},
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "accounts", {
        get: function get() {
          return this._walletConnector.accounts;
        },
        set: function set(t) {},
        enumerable: !0,
        configurable: !0
      }), e.prototype.createSession = function () {
        return n.__awaiter(this, void 0, void 0, function () {
          return n.__generator(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this._walletConnector.createSession()];

              case 1:
                return [2, t.sent()];
            }
          });
        });
      }, e.prototype.setEngine = function (t) {
        this.engine = t;
      }, e.prototype.handleRequest = function (t, e, r) {
        return n.__awaiter(this, void 0, void 0, function () {
          var o, i;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                switch (t.method) {
                  case "eth_accounts":
                    return [3, 1];

                  case "eth_signTransaction":
                  case "eth_sendTransaction":
                  case "eth_sendRawTransaction":
                  case "eth_sign":
                  case "eth_signTypedData":
                  case "eth_signTypedData_v1":
                  case "eth_signTypedData_v3":
                  case "personal_sign":
                    return [3, 2];
                }

                return [3, 6];

              case 1:
                return r(null, this.accounts), [2];

              case 2:
                return n.trys.push([2, 4,, 5]), [4, this._walletConnector._sendCallRequest(t)];

              case 3:
                return o = n.sent(), r(null, o.result), [3, 5];

              case 4:
                return i = n.sent(), r(i), [3, 5];

              case 5:
                return [2];

              case 6:
                e(), n.label = 7;

              case 7:
                return [2];
            }
          });
        });
      }, e.prototype.sendAsync = function (t, e) {
        var r = this;
        this.handleRequest(t, function () {
          r.engine.sendAsync.bind(r)(t, e);
        }, function (r, o) {
          return r ? e(r) : e(null, n.__assign({}, t, {
            result: o
          }));
        });
      }, e;
    }(n.__importDefault(r(3)).default);

    e.default = i;
  }, function (t, e, r) {
    window, t.exports = function (t) {
      var e = {};

      function r(n) {
        if (e[n]) return e[n].exports;
        var o = e[n] = {
          i: n,
          l: !1,
          exports: {}
        };
        return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
      }

      return r.m = t, r.c = e, r.d = function (t, e, n) {
        r.o(t, e) || Object.defineProperty(t, e, {
          enumerable: !0,
          get: n
        });
      }, r.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }, r.t = function (t, e) {
        if (1 & e && (t = r(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
          enumerable: !0,
          value: t
        }), 2 & e && "string" != typeof t) for (var o in t) {
          r.d(n, o, function (e) {
            return t[e];
          }.bind(null, o));
        }
        return n;
      }, r.n = function (t) {
        var e = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return r.d(e, "a", e), e;
      }, r.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, r.p = "", r(r.s = 1);
    }([function (t, e, r) {
      "use strict";

      r.r(e), r.d(e, "__extends", function () {
        return o;
      }), r.d(e, "__assign", function () {
        return _i2;
      }), r.d(e, "__rest", function () {
        return u;
      }), r.d(e, "__decorate", function () {
        return a;
      }), r.d(e, "__param", function () {
        return s;
      }), r.d(e, "__metadata", function () {
        return f;
      }), r.d(e, "__awaiter", function () {
        return c;
      }), r.d(e, "__generator", function () {
        return h;
      }), r.d(e, "__exportStar", function () {
        return l;
      }), r.d(e, "__values", function () {
        return p;
      }), r.d(e, "__read", function () {
        return d;
      }), r.d(e, "__spread", function () {
        return y;
      }), r.d(e, "__await", function () {
        return g;
      }), r.d(e, "__asyncGenerator", function () {
        return v;
      }), r.d(e, "__asyncDelegator", function () {
        return _;
      }), r.d(e, "__asyncValues", function () {
        return w;
      }), r.d(e, "__makeTemplateObject", function () {
        return b;
      }), r.d(e, "__importStar", function () {
        return m;
      }), r.d(e, "__importDefault", function () {
        return S;
      });
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */

      var _n2 = function n(t, e) {
        return (_n2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var r in e) {
            e.hasOwnProperty(r) && (t[r] = e[r]);
          }
        })(t, e);
      };

      function o(t, e) {
        function r() {
          this.constructor = t;
        }

        _n2(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }

      var _i2 = function i() {
        return (_i2 = Object.assign || function (t) {
          for (var e, r = 1, n = arguments.length; r < n; r++) {
            for (var o in e = arguments[r]) {
              Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            }
          }

          return t;
        }).apply(this, arguments);
      };

      function u(t, e) {
        var r = {};

        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
        }

        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;

          for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) {
            e.indexOf(n[o]) < 0 && (r[n[o]] = t[n[o]]);
          }
        }

        return r;
      }

      function a(t, e, r, n) {
        var o,
            i = arguments.length,
            u = i < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) u = Reflect.decorate(t, e, r, n);else for (var a = t.length - 1; a >= 0; a--) {
          (o = t[a]) && (u = (i < 3 ? o(u) : i > 3 ? o(e, r, u) : o(e, r)) || u);
        }
        return i > 3 && u && Object.defineProperty(e, r, u), u;
      }

      function s(t, e) {
        return function (r, n) {
          e(r, n, t);
        };
      }

      function f(t, e) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
      }

      function c(t, e, r, n) {
        return new (r || (r = Promise))(function (o, i) {
          function u(t) {
            try {
              s(n.next(t));
            } catch (t) {
              i(t);
            }
          }

          function a(t) {
            try {
              s(n.throw(t));
            } catch (t) {
              i(t);
            }
          }

          function s(t) {
            t.done ? o(t.value) : new r(function (e) {
              e(t.value);
            }).then(u, a);
          }

          s((n = n.apply(t, e || [])).next());
        });
      }

      function h(t, e) {
        var r,
            n,
            o,
            i,
            u = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function a(i) {
          return function (a) {
            return function (i) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; u;) {
                try {
                  if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                  switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                    case 0:
                    case 1:
                      o = i;
                      break;

                    case 4:
                      return u.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      u.label++, n = i[1], i = [0];
                      continue;

                    case 7:
                      i = u.ops.pop(), u.trys.pop();
                      continue;

                    default:
                      if (!(o = (o = u.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                        u = 0;
                        continue;
                      }

                      if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                        u.label = i[1];
                        break;
                      }

                      if (6 === i[0] && u.label < o[1]) {
                        u.label = o[1], o = i;
                        break;
                      }

                      if (o && u.label < o[2]) {
                        u.label = o[2], u.ops.push(i);
                        break;
                      }

                      o[2] && u.ops.pop(), u.trys.pop();
                      continue;
                  }

                  i = e.call(t, u);
                } catch (t) {
                  i = [6, t], n = 0;
                } finally {
                  r = o = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, a]);
          };
        }
      }

      function l(t, e) {
        for (var r in t) {
          e.hasOwnProperty(r) || (e[r] = t[r]);
        }
      }

      function p(t) {
        var e = "function" == typeof Symbol && t[Symbol.iterator],
            r = 0;
        return e ? e.call(t) : {
          next: function next() {
            return t && r >= t.length && (t = void 0), {
              value: t && t[r++],
              done: !t
            };
          }
        };
      }

      function d(t, e) {
        var r = "function" == typeof Symbol && t[Symbol.iterator];
        if (!r) return t;
        var n,
            o,
            i = r.call(t),
            u = [];

        try {
          for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) {
            u.push(n.value);
          }
        } catch (t) {
          o = {
            error: t
          };
        } finally {
          try {
            n && !n.done && (r = i.return) && r.call(i);
          } finally {
            if (o) throw o.error;
          }
        }

        return u;
      }

      function y() {
        for (var t = [], e = 0; e < arguments.length; e++) {
          t = t.concat(d(arguments[e]));
        }

        return t;
      }

      function g(t) {
        return this instanceof g ? (this.v = t, this) : new g(t);
      }

      function v(t, e, r) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var n,
            o = r.apply(t, e || []),
            i = [];
        return n = {}, u("next"), u("throw"), u("return"), n[Symbol.asyncIterator] = function () {
          return this;
        }, n;

        function u(t) {
          o[t] && (n[t] = function (e) {
            return new Promise(function (r, n) {
              i.push([t, e, r, n]) > 1 || a(t, e);
            });
          });
        }

        function a(t, e) {
          try {
            (r = o[t](e)).value instanceof g ? Promise.resolve(r.value.v).then(s, f) : c(i[0][2], r);
          } catch (t) {
            c(i[0][3], t);
          }

          var r;
        }

        function s(t) {
          a("next", t);
        }

        function f(t) {
          a("throw", t);
        }

        function c(t, e) {
          t(e), i.shift(), i.length && a(i[0][0], i[0][1]);
        }
      }

      function _(t) {
        var e, r;
        return e = {}, n("next"), n("throw", function (t) {
          throw t;
        }), n("return"), e[Symbol.iterator] = function () {
          return this;
        }, e;

        function n(n, o) {
          e[n] = t[n] ? function (e) {
            return (r = !r) ? {
              value: g(t[n](e)),
              done: "return" === n
            } : o ? o(e) : e;
          } : o;
        }
      }

      function w(t) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var e,
            r = t[Symbol.asyncIterator];
        return r ? r.call(t) : (t = p(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
          return this;
        }, e);

        function n(r) {
          e[r] = t[r] && function (e) {
            return new Promise(function (n, o) {
              !function (t, e, r, n) {
                Promise.resolve(n).then(function (e) {
                  t({
                    value: e,
                    done: r
                  });
                }, e);
              }(n, o, (e = t[r](e)).done, e.value);
            });
          };
        }
      }

      function b(t, e) {
        return Object.defineProperty ? Object.defineProperty(t, "raw", {
          value: e
        }) : t.raw = e, t;
      }

      function m(t) {
        if (t && t.__esModule) return t;
        var e = {};
        if (null != t) for (var r in t) {
          Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
        return e.default = t, e;
      }

      function S(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }
    }, function (t, e, r) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var n = r(0),
          o = n.__importDefault(r(2)),
          i = n.__importStar(r(3)),
          u = function (t) {
        function e(e) {
          return t.call(this, i, e, !0) || this;
        }

        return n.__extends(e, t), e;
      }(o.default);

      e.default = u;
    }, function (t, e, r) {
      window, t.exports = function (t) {
        var e = {};

        function r(n) {
          if (e[n]) return e[n].exports;
          var o = e[n] = {
            i: n,
            l: !1,
            exports: {}
          };
          return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
        }

        return r.m = t, r.c = e, r.d = function (t, e, n) {
          r.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: n
          });
        }, r.r = function (t) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(t, "__esModule", {
            value: !0
          });
        }, r.t = function (t, e) {
          if (1 & e && (t = r(t)), 8 & e) return t;
          if (4 & e && "object" == typeof t && t && t.__esModule) return t;
          var n = Object.create(null);
          if (r.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: t
          }), 2 & e && "string" != typeof t) for (var o in t) {
            r.d(n, o, function (e) {
              return t[e];
            }.bind(null, o));
          }
          return n;
        }, r.n = function (t) {
          var e = t && t.__esModule ? function () {
            return t.default;
          } : function () {
            return t;
          };
          return r.d(e, "a", e), e;
        }, r.o = function (t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }, r.p = "", r(r.s = 0);
      }([function (t, e, r) {
        "use strict";

        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(1),
            o = r(2);

        function i(t) {
          return "result" in t;
        }

        function u(t) {
          return "error" in t;
        }

        var a = null;
        "undefined" != typeof window && void 0 !== window.localStorage && (a = window.localStorage);

        var s = function () {
          function t(t, e, r, n) {
            if (this.cryptoLib = t, this.protocol = "wc", this.version = 1, this._bridge = "", this._key = null, this._nextKey = null, this._clientId = "", this._clientMeta = null, this._peerId = "", this._peerMeta = null, this._handshakeId = 0, this._handshakeTopic = "", this._accounts = [], this._chainId = 0, this._socket = null, this._queue = [], this._eventEmitters = [], this._connected = !1, this._browser = r, this._pingInterval = null, r && "https:" !== window.location.protocol && "localhost" !== window.location.hostname) throw new Error("HTTPS is required for non-localhost origins");
            if (n && (this.clientMeta = n), !e.bridge && !e.uri && !e.session) throw new Error("Missing one of two required parameters: bridge / uri / session");
            e.bridge && (this.bridge = e.bridge), e.uri && (this.uri = e.uri, this._subscribeToSessionRequest());

            var o = e.session || this._getStorageSession();

            o && (this.session = o, this._browser && this._exchangeKey()), this.handshakeId && this._subscribeToSessionResponse(this.handshakeId, "Session request rejected"), this._subscribeToInternalEvents(), this._socketOpen();
          }

          return Object.defineProperty(t.prototype, "bridge", {
            get: function get() {
              return this._bridge;
            },
            set: function set(t) {
              t && (this._bridge = t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "key", {
            get: function get() {
              return this._key ? o.convertArrayBufferToHex(this._key) : "";
            },
            set: function set(t) {
              if (t) {
                var e = o.convertHexToArrayBuffer(t);
                this._key = e;
              }
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "nextKey", {
            get: function get() {
              return this._nextKey ? o.convertArrayBufferToHex(this._nextKey) : "";
            },
            set: function set(t) {
              if (t) {
                var e = o.convertHexToArrayBuffer(t);
                this._nextKey = e;
              }
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "clientId", {
            get: function get() {
              var t = this._clientId;
              return t || (t = this._clientId = o.uuid()), this._clientId;
            },
            set: function set(t) {
              t && (this._clientId = t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "peerId", {
            get: function get() {
              return this._peerId;
            },
            set: function set(t) {
              t && (this._peerId = t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "clientMeta", {
            get: function get() {
              var t = this._clientMeta;
              return t || (t = this._clientMeta = o.getMeta()), t;
            },
            set: function set(t) {},
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "peerMeta", {
            get: function get() {
              return this._peerMeta;
            },
            set: function set(t) {
              this._peerMeta = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "handshakeTopic", {
            get: function get() {
              return this._handshakeTopic;
            },
            set: function set(t) {
              t && (this._handshakeTopic = t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "handshakeId", {
            get: function get() {
              return this._handshakeId;
            },
            set: function set(t) {
              t && (this._handshakeId = t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "uri", {
            get: function get() {
              return this._formatUri();
            },
            set: function set(t) {
              if (t) {
                var e = this._parseUri(t),
                    r = e.handshakeTopic,
                    n = e.bridge,
                    o = e.key;

                this.handshakeTopic = r, this.bridge = n, this.key = o;
              }
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "chainId", {
            get: function get() {
              return this._chainId;
            },
            set: function set(t) {
              this._chainId = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "accounts", {
            get: function get() {
              return this._accounts;
            },
            set: function set(t) {
              this._accounts = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "connected", {
            get: function get() {
              return this._connected;
            },
            set: function set(t) {},
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "pending", {
            get: function get() {
              return !!this._handshakeTopic;
            },
            set: function set(t) {},
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "session", {
            get: function get() {
              return {
                connected: this.connected,
                accounts: this.accounts,
                chainId: this.chainId,
                bridge: this.bridge,
                key: this.key,
                clientId: this.clientId,
                clientMeta: this.clientMeta,
                peerId: this.peerId,
                peerMeta: this.peerMeta,
                handshakeId: this.handshakeId,
                handshakeTopic: this.handshakeTopic
              };
            },
            set: function set(t) {
              t && (this._connected = t.connected, this.accounts = t.accounts, this.chainId = t.chainId, this.bridge = t.bridge, this.key = t.key, this.clientId = t.clientId, this.clientMeta = t.clientMeta, this.peerId = t.peerId, this.peerMeta = t.peerMeta, this.handshakeId = t.handshakeId, this.handshakeTopic = t.handshakeTopic);
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.on = function (t, e) {
            var r = {
              event: t,
              callback: e
            };

            this._eventEmitters.push(r);
          }, t.prototype.createSession = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e, r;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    if (this._connected) throw new Error("Session currently connected");
                    return this.pending ? [2] : (e = this, [4, this._generateKey()]);

                  case 1:
                    return e._key = n.sent(), r = this._formatRequest({
                      method: "wc_sessionRequest",
                      params: [{
                        peerId: this.clientId,
                        peerMeta: this.clientMeta,
                        chainId: t && t.chainId ? t.chainId : null
                      }]
                    }), this.handshakeId = r.id, this.handshakeTopic = o.uuid(), this._sendSessionRequest(r, "Session update rejected", this.handshakeTopic), [2];
                }
              });
            });
          }, t.prototype.approveSession = function (t) {
            if (this._connected) throw new Error("Session currently connected");
            this.chainId = t.chainId, this.accounts = t.accounts;
            var e = {
              approved: !0,
              chainId: this.chainId,
              accounts: this.accounts
            },
                r = {
              id: this.handshakeId,
              jsonrpc: "2.0",
              result: e
            };
            this._sendResponse(r), this._connected = !0, this._triggerEvents({
              event: "connect",
              params: [{
                peerId: this.peerId,
                peerMeta: this.peerMeta,
                chainId: this.chainId,
                accounts: this.accounts
              }]
            }), this._connected ? this._setStorageSession() : this._removeStorageSession();
          }, t.prototype.rejectSession = function (t) {
            if (this._connected) throw new Error("Session currently connected");

            var e = t && t.message ? t.message : "Session Rejected",
                r = this._formatResponse({
              id: this.handshakeId,
              error: {
                message: e
              }
            });

            this._sendResponse(r), this._connected = !1, this._triggerEvents({
              event: "disconnect",
              params: [{
                message: e
              }]
            }), this._removeStorageSession();
          }, t.prototype.updateSession = function (t) {
            if (!this._connected) throw new Error("Session currently disconnected");
            this.chainId = t.chainId, this.accounts = t.accounts;

            var e = {
              approved: !0,
              chainId: this.chainId,
              accounts: this.accounts
            },
                r = this._formatRequest({
              method: "wc_sessionUpdate",
              params: [e]
            });

            this._sendSessionRequest(r, "Session update rejected"), this._triggerEvents({
              event: "session_update",
              params: [{
                chainId: this.chainId,
                accounts: this.accounts
              }]
            }), this._connected ? this._setStorageSession() : this._removeStorageSession();
          }, t.prototype.killSession = function (t) {
            var e = t ? t.message : "Session Disconnected",
                r = this._formatRequest({
              method: "wc_sessionUpdate",
              params: [{
                approved: !1,
                chainId: null,
                accounts: null
              }]
            });

            this._sendSessionRequest(r, "Failed to kill Session"), this._handleSessionDisconnect(e);
          }, t.prototype.sendTransaction = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!this._connected) throw new Error("Session currently disconnected");
                    e = this._formatRequest({
                      method: "eth_sendTransaction",
                      params: [t]
                    }), r.label = 1;

                  case 1:
                    return r.trys.push([1, 3,, 4]), [4, this._sendCallRequest(e)];

                  case 2:
                    return [2, r.sent()];

                  case 3:
                    throw r.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.signMessage = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!this._connected) throw new Error("Session currently disconnected");
                    e = this._formatRequest({
                      method: "eth_sign",
                      params: t
                    }), r.label = 1;

                  case 1:
                    return r.trys.push([1, 3,, 4]), [4, this._sendCallRequest(e)];

                  case 2:
                    return [2, r.sent()];

                  case 3:
                    throw r.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.signPersonalMessage = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!this._connected) throw new Error("Session currently disconnected");
                    o.isHexStrict(t[1]) || (t[1] = o.convertUtf8ToHex(t[1])), e = this._formatRequest({
                      method: "personal_sign",
                      params: t
                    }), r.label = 1;

                  case 1:
                    return r.trys.push([1, 3,, 4]), [4, this._sendCallRequest(e)];

                  case 2:
                    return [2, r.sent()];

                  case 3:
                    throw r.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.signTypedData = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!this._connected) throw new Error("Session currently disconnected");
                    e = this._formatRequest({
                      method: "eth_signTypedData",
                      params: t
                    }), r.label = 1;

                  case 1:
                    return r.trys.push([1, 3,, 4]), [4, this._sendCallRequest(e)];

                  case 2:
                    return [2, r.sent()];

                  case 3:
                    throw r.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.sendCustomRequest = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!this._connected) throw new Error("Session currently disconnected");
                    e = this._formatRequest(t), r.label = 1;

                  case 1:
                    return r.trys.push([1, 3,, 4]), [4, this._sendCallRequest(e)];

                  case 2:
                    return [2, r.sent()];

                  case 3:
                    throw r.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.approveRequest = function (t) {
            if (!i(t)) throw new Error('JSON-RPC success response must include "result" field');

            var e = this._formatResponse(t);

            this._sendResponse(e);
          }, t.prototype.rejectRequest = function (t) {
            if (!u(t)) throw new Error('JSON-RPC error response must include "error" field');

            var e = this._formatResponse(t);

            this._sendResponse(e);
          }, t.prototype._sendRequest = function (t, e) {
            return n.__awaiter(this, void 0, void 0, function () {
              var r, o, i, u, a;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    return r = this._formatRequest(t), [4, this._encrypt(r)];

                  case 1:
                    return o = n.sent(), i = e || this.peerId, u = JSON.stringify(o), a = {
                      topic: i,
                      type: "pub",
                      payload: u
                    }, this._socket && 1 === this._socket.readyState ? this._socketSend(a) : this._setToQueue(a), [2];
                }
              });
            });
          }, t.prototype._sendResponse = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e, r, o, i;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    return [4, this._encrypt(t)];

                  case 1:
                    return e = n.sent(), r = this.peerId, o = JSON.stringify(e), i = {
                      topic: r,
                      type: "pub",
                      payload: o
                    }, this._socket && 1 === this._socket.readyState ? this._socketSend(i) : this._setToQueue(i), [2];
                }
              });
            });
          }, t.prototype._sendSessionRequest = function (t, e, r) {
            return n.__awaiter(this, void 0, void 0, function () {
              return n.__generator(this, function (n) {
                return this._sendRequest(t, r), this._subscribeToSessionResponse(t.id, e), [2];
              });
            });
          }, t.prototype._sendCallRequest = function (t) {
            return this._sendRequest(t), this._subscribeToCallResponse(t.id);
          }, t.prototype._formatRequest = function (t) {
            return n.__assign({
              id: o.payloadId(),
              jsonrpc: "2.0"
            }, t);
          }, t.prototype._formatResponse = function (t) {
            if (u(t)) {
              var e = o.formatRpcError(t.error);
              return n.__assign({
                jsonrpc: "2.0"
              }, t, {
                error: e
              });
            }

            return n.__assign({
              jsonrpc: "2.0",
              result: null
            }, t);
          }, t.prototype._handleSessionDisconnect = function (t) {
            var e = t || "Session Disconnected";
            this._connected && (this._connected = !1, this._triggerEvents({
              event: "disconnect",
              params: [{
                message: e
              }]
            }), console.error(e)), this._removeStorageSession(), this._toggleSocketPing();
          }, t.prototype._handleSessionResponse = function (t, e) {
            e && e.approved ? (this._connected ? (e.chainId && (this.chainId = e.chainId), e.accounts && (this.accounts = e.accounts), this._triggerEvents({
              event: "session_update",
              params: [{
                chainId: this.chainId,
                accounts: this.accounts
              }]
            })) : (this._connected = !0, e.chainId && (this.chainId = e.chainId), e.accounts && (this.accounts = e.accounts), this._triggerEvents({
              event: "connect",
              params: [{
                peerId: this.peerId,
                peerMeta: this.peerMeta,
                chainId: this.chainId,
                accounts: this.accounts
              }]
            })), this._connected ? this._setStorageSession() : this._removeStorageSession()) : this._handleSessionDisconnect(t);
          }, t.prototype._subscribeToSessionRequest = function () {
            this._setToQueue({
              topic: "" + this.handshakeTopic,
              type: "sub",
              payload: ""
            });
          }, t.prototype._subscribeToSessionResponse = function (t, e) {
            var r = this;
            this.on("response:" + t, function (t, n) {
              t && r._handleSessionResponse(t.message), r._handleSessionResponse(e, n.result);
            });
          }, t.prototype._subscribeToCallResponse = function (t) {
            var e = this;
            return new Promise(function (r, n) {
              e.on("response:" + t, function (t, e) {
                t && n(t), e.result ? r(e.result) : e.error && e.error.message ? n(new Error(e.error.message)) : n(new Error("Invalid JSON RPC response format received"));
              });
            });
          }, t.prototype._subscribeToInternalEvents = function () {
            var t = this;
            this.on("wc_sessionRequest", function (e, r) {
              e && console.error(e), t.handshakeId = r.id, t.peerId = r.params[0].peerId, t.peerMeta = r.params[0].peerMeta, t._exchangeKey();

              var o = n.__assign({}, r, {
                method: "session_request"
              });

              t._triggerEvents(o);
            }), this.on("wc_sessionUpdate", function (e, r) {
              e && t._handleSessionResponse(e.message), t._handleSessionResponse("Session disconnected", r.params[0]);
            }), this.on("wc_exchangeKey", function (e, r) {
              e && console.error(e), t._handleExchangeKeyRequest(r);
            });
          }, t.prototype._triggerEvents = function (t) {
            var e,
                r = [];
            (e = "method" in t ? t.method : i(t) || u(t) ? "response:" + t.id : function (t) {
              return "event" in t;
            }(t) ? t.event : "") && (r = this._eventEmitters.filter(function (t) {
              return t.event === e;
            })), r && r.length || (r = this._eventEmitters.filter(function (t) {
              return "call_request" === t.event;
            })), r.forEach(function (e) {
              if (u(t)) {
                var r = new Error(t.error.message);
                e.callback(r, null);
              } else e.callback(null, t);
            });
          }, t.prototype._exchangeKey = function () {
            return n.__awaiter(this, void 0, void 0, function () {
              var t, e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    return t = this, [4, this._generateKey()];

                  case 1:
                    t._nextKey = r.sent(), e = this._formatRequest({
                      method: "wc_exchangeKey",
                      params: [{
                        peerId: this.clientId,
                        peerMeta: this.clientMeta,
                        nextKey: this.nextKey
                      }]
                    }), r.label = 2;

                  case 2:
                    return r.trys.push([2, 4,, 5]), [4, this._sendCallRequest(e)];

                  case 3:
                    return r.sent(), this._swapKey(), [3, 5];

                  case 4:
                    throw r.sent();

                  case 5:
                    return [2];
                }
              });
            });
          }, t.prototype._handleExchangeKeyRequest = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e, r, o, i, u;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    return e = t.params[0], r = e.peerId, o = e.peerMeta, i = e.nextKey, this.peerId = r, this.peerMeta = o, this.nextKey = i, u = {
                      id: t.id,
                      jsonrpc: "2.0",
                      result: !0
                    }, [4, this._sendResponse(u)];

                  case 1:
                    return n.sent(), this._swapKey(), [2];
                }
              });
            });
          }, t.prototype._swapKey = function () {
            this._key = this._nextKey, this._nextKey = null, this._connected ? this._setStorageSession() : this._removeStorageSession();
          }, t.prototype._socketOpen = function () {
            var t = this,
                e = this.bridge,
                r = e.startsWith("https") ? e.replace("https", "wss") : e.startsWith("http") ? e.replace("http", "ws") : e,
                n = new WebSocket(r);
            n.onmessage = function (e) {
              return t._socketReceive(e);
            }, n.onopen = function () {
              t._socket = n, t._setToQueue({
                topic: "" + t.clientId,
                type: "sub",
                payload: ""
              }), t._dispatchQueue(), t._toggleSocketPing();
            };
          }, t.prototype._toggleSocketPing = function () {
            var t = this;
            this._socket && 1 === this._socket.readyState ? this._pingInterval = setInterval(function () {
              t._socket && t._socket.send("ping");
            }, 1e4) : clearInterval(this._pingInterval);
          }, t.prototype._socketSend = function (t) {
            if (!this._socket) throw new Error("Missing socket: required for sending message");
            var e = JSON.stringify(t);
            this._socket && 1 === this._socket.readyState ? this._socket.send(e) : this._connected && (this._setToQueue(t), this._socketOpen());
          }, t.prototype._socketReceive = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e, r, o;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    try {
                      e = JSON.parse(t.data);
                    } catch (t) {
                      throw t;
                    }

                    if (![this.clientId, this.handshakeTopic].includes(e.topic)) return [2];

                    try {
                      r = JSON.parse(e.payload);
                    } catch (t) {
                      throw t;
                    }

                    return [4, this._decrypt(r)];

                  case 1:
                    return (o = n.sent()) && this._triggerEvents(o), [2];
                }
              });
            });
          }, t.prototype._setToQueue = function (t) {
            this._queue.push(t);
          }, t.prototype._dispatchQueue = function () {
            var t = this;
            this._queue.forEach(function (e) {
              return t._socketSend(e);
            }), this._queue = [];
          }, t.prototype._formatUri = function () {
            return this.protocol + ":" + this.handshakeTopic + "@" + this.version + "?bridge=" + encodeURIComponent(this.bridge) + "&key=" + this.key;
          }, t.prototype._parseUri = function (t) {
            var e = o.parseWalletConnectUri(t);

            if (e.protocol === this.protocol) {
              if (!e.handshakeTopic) throw Error("Invalid or missing handshakeTopic parameter value");
              var r = e.handshakeTopic;
              if (!e.bridge) throw Error("Invalid or missing bridge url parameter value");
              var n = decodeURIComponent(e.bridge);
              if (!e.key) throw Error("Invalid or missing kkey parameter value");
              return {
                handshakeTopic: r,
                bridge: n,
                key: e.key
              };
            }

            throw new Error("URI format doesn't follow Connector protocol");
          }, t.prototype._generateKey = function () {
            return n.__awaiter(this, void 0, void 0, function () {
              return n.__generator(this, function (t) {
                switch (t.label) {
                  case 0:
                    return this.cryptoLib ? [4, this.cryptoLib.generateKey()] : [3, 2];

                  case 1:
                    return [2, t.sent()];

                  case 2:
                    return [2, null];
                }
              });
            });
          }, t.prototype._encrypt = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    return e = this._key, this.cryptoLib && e ? [4, this.cryptoLib.encrypt(t, e)] : [3, 2];

                  case 1:
                    return [2, r.sent()];

                  case 2:
                    return [2, null];
                }
              });
            });
          }, t.prototype._decrypt = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    return e = this._key, this.cryptoLib && e ? [4, this.cryptoLib.decrypt(t, e)] : [3, 2];

                  case 1:
                    return [2, r.sent()];

                  case 2:
                    return [2, null];
                }
              });
            });
          }, t.prototype._getStorageSession = function () {
            var t = null,
                e = null;
            if (a && (e = a.getItem("walletconnect")), e && "string" == typeof e) try {
              var r = JSON.parse(e);
              "bridge" in r && (t = r);
            } catch (t) {
              throw t;
            }
            return t;
          }, t.prototype._setStorageSession = function () {
            var t = this.session,
                e = JSON.stringify(t);
            return a && a.setItem("walletconnect", e), t;
          }, t.prototype._removeStorageSession = function () {
            a && a.removeItem("walletconnect");
          }, t;
        }();

        e.default = s;
      }, function (t, e, r) {
        "use strict";

        r.r(e), r.d(e, "__extends", function () {
          return o;
        }), r.d(e, "__assign", function () {
          return _i3;
        }), r.d(e, "__rest", function () {
          return u;
        }), r.d(e, "__decorate", function () {
          return a;
        }), r.d(e, "__param", function () {
          return s;
        }), r.d(e, "__metadata", function () {
          return f;
        }), r.d(e, "__awaiter", function () {
          return c;
        }), r.d(e, "__generator", function () {
          return h;
        }), r.d(e, "__exportStar", function () {
          return l;
        }), r.d(e, "__values", function () {
          return p;
        }), r.d(e, "__read", function () {
          return d;
        }), r.d(e, "__spread", function () {
          return y;
        }), r.d(e, "__await", function () {
          return g;
        }), r.d(e, "__asyncGenerator", function () {
          return v;
        }), r.d(e, "__asyncDelegator", function () {
          return _;
        }), r.d(e, "__asyncValues", function () {
          return w;
        }), r.d(e, "__makeTemplateObject", function () {
          return b;
        }), r.d(e, "__importStar", function () {
          return m;
        }), r.d(e, "__importDefault", function () {
          return S;
        });
        /*! *****************************************************************************
        Copyright (c) Microsoft Corporation. All rights reserved.
        Licensed under the Apache License, Version 2.0 (the "License"); you may not use
        this file except in compliance with the License. You may obtain a copy of the
        License at http://www.apache.org/licenses/LICENSE-2.0
        
        THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
        WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
        MERCHANTABLITY OR NON-INFRINGEMENT.
        
        See the Apache Version 2.0 License for specific language governing permissions
        and limitations under the License.
        ***************************************************************************** */

        var _n3 = function n(t, e) {
          return (_n3 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (t, e) {
            t.__proto__ = e;
          } || function (t, e) {
            for (var r in e) {
              e.hasOwnProperty(r) && (t[r] = e[r]);
            }
          })(t, e);
        };

        function o(t, e) {
          function r() {
            this.constructor = t;
          }

          _n3(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
        }

        var _i3 = function i() {
          return (_i3 = Object.assign || function (t) {
            for (var e, r = 1, n = arguments.length; r < n; r++) {
              for (var o in e = arguments[r]) {
                Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              }
            }

            return t;
          }).apply(this, arguments);
        };

        function u(t, e) {
          var r = {};

          for (var n in t) {
            Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
          }

          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;

            for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) {
              e.indexOf(n[o]) < 0 && (r[n[o]] = t[n[o]]);
            }
          }

          return r;
        }

        function a(t, e, r, n) {
          var o,
              i = arguments.length,
              u = i < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
          if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) u = Reflect.decorate(t, e, r, n);else for (var a = t.length - 1; a >= 0; a--) {
            (o = t[a]) && (u = (i < 3 ? o(u) : i > 3 ? o(e, r, u) : o(e, r)) || u);
          }
          return i > 3 && u && Object.defineProperty(e, r, u), u;
        }

        function s(t, e) {
          return function (r, n) {
            e(r, n, t);
          };
        }

        function f(t, e) {
          if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
        }

        function c(t, e, r, n) {
          return new (r || (r = Promise))(function (o, i) {
            function u(t) {
              try {
                s(n.next(t));
              } catch (t) {
                i(t);
              }
            }

            function a(t) {
              try {
                s(n.throw(t));
              } catch (t) {
                i(t);
              }
            }

            function s(t) {
              t.done ? o(t.value) : new r(function (e) {
                e(t.value);
              }).then(u, a);
            }

            s((n = n.apply(t, e || [])).next());
          });
        }

        function h(t, e) {
          var r,
              n,
              o,
              i,
              u = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
          return i = {
            next: a(0),
            throw: a(1),
            return: a(2)
          }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
            return this;
          }), i;

          function a(i) {
            return function (a) {
              return function (i) {
                if (r) throw new TypeError("Generator is already executing.");

                for (; u;) {
                  try {
                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                    switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                      case 0:
                      case 1:
                        o = i;
                        break;

                      case 4:
                        return u.label++, {
                          value: i[1],
                          done: !1
                        };

                      case 5:
                        u.label++, n = i[1], i = [0];
                        continue;

                      case 7:
                        i = u.ops.pop(), u.trys.pop();
                        continue;

                      default:
                        if (!(o = (o = u.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                          u = 0;
                          continue;
                        }

                        if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                          u.label = i[1];
                          break;
                        }

                        if (6 === i[0] && u.label < o[1]) {
                          u.label = o[1], o = i;
                          break;
                        }

                        if (o && u.label < o[2]) {
                          u.label = o[2], u.ops.push(i);
                          break;
                        }

                        o[2] && u.ops.pop(), u.trys.pop();
                        continue;
                    }

                    i = e.call(t, u);
                  } catch (t) {
                    i = [6, t], n = 0;
                  } finally {
                    r = o = 0;
                  }
                }

                if (5 & i[0]) throw i[1];
                return {
                  value: i[0] ? i[1] : void 0,
                  done: !0
                };
              }([i, a]);
            };
          }
        }

        function l(t, e) {
          for (var r in t) {
            e.hasOwnProperty(r) || (e[r] = t[r]);
          }
        }

        function p(t) {
          var e = "function" == typeof Symbol && t[Symbol.iterator],
              r = 0;
          return e ? e.call(t) : {
            next: function next() {
              return t && r >= t.length && (t = void 0), {
                value: t && t[r++],
                done: !t
              };
            }
          };
        }

        function d(t, e) {
          var r = "function" == typeof Symbol && t[Symbol.iterator];
          if (!r) return t;
          var n,
              o,
              i = r.call(t),
              u = [];

          try {
            for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) {
              u.push(n.value);
            }
          } catch (t) {
            o = {
              error: t
            };
          } finally {
            try {
              n && !n.done && (r = i.return) && r.call(i);
            } finally {
              if (o) throw o.error;
            }
          }

          return u;
        }

        function y() {
          for (var t = [], e = 0; e < arguments.length; e++) {
            t = t.concat(d(arguments[e]));
          }

          return t;
        }

        function g(t) {
          return this instanceof g ? (this.v = t, this) : new g(t);
        }

        function v(t, e, r) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var n,
              o = r.apply(t, e || []),
              i = [];
          return n = {}, u("next"), u("throw"), u("return"), n[Symbol.asyncIterator] = function () {
            return this;
          }, n;

          function u(t) {
            o[t] && (n[t] = function (e) {
              return new Promise(function (r, n) {
                i.push([t, e, r, n]) > 1 || a(t, e);
              });
            });
          }

          function a(t, e) {
            try {
              (r = o[t](e)).value instanceof g ? Promise.resolve(r.value.v).then(s, f) : c(i[0][2], r);
            } catch (t) {
              c(i[0][3], t);
            }

            var r;
          }

          function s(t) {
            a("next", t);
          }

          function f(t) {
            a("throw", t);
          }

          function c(t, e) {
            t(e), i.shift(), i.length && a(i[0][0], i[0][1]);
          }
        }

        function _(t) {
          var e, r;
          return e = {}, n("next"), n("throw", function (t) {
            throw t;
          }), n("return"), e[Symbol.iterator] = function () {
            return this;
          }, e;

          function n(n, o) {
            e[n] = t[n] ? function (e) {
              return (r = !r) ? {
                value: g(t[n](e)),
                done: "return" === n
              } : o ? o(e) : e;
            } : o;
          }
        }

        function w(t) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var e,
              r = t[Symbol.asyncIterator];
          return r ? r.call(t) : (t = p(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
            return this;
          }, e);

          function n(r) {
            e[r] = t[r] && function (e) {
              return new Promise(function (n, o) {
                !function (t, e, r, n) {
                  Promise.resolve(n).then(function (e) {
                    t({
                      value: e,
                      done: r
                    });
                  }, e);
                }(n, o, (e = t[r](e)).done, e.value);
              });
            };
          }
        }

        function b(t, e) {
          return Object.defineProperty ? Object.defineProperty(t, "raw", {
            value: e
          }) : t.raw = e, t;
        }

        function m(t) {
          if (t && t.__esModule) return t;
          var e = {};
          if (null != t) for (var r in t) {
            Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
          return e.default = t, e;
        }

        function S(t) {
          return t && t.__esModule ? t : {
            default: t
          };
        }
      }, function (t, e, r) {
        window, t.exports = function (t) {
          var e = {};

          function r(n) {
            if (e[n]) return e[n].exports;
            var o = e[n] = {
              i: n,
              l: !1,
              exports: {}
            };
            return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
          }

          return r.m = t, r.c = e, r.d = function (t, e, n) {
            r.o(t, e) || Object.defineProperty(t, e, {
              enumerable: !0,
              get: n
            });
          }, r.r = function (t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
              value: "Module"
            }), Object.defineProperty(t, "__esModule", {
              value: !0
            });
          }, r.t = function (t, e) {
            if (1 & e && (t = r(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
              enumerable: !0,
              value: t
            }), 2 & e && "string" != typeof t) for (var o in t) {
              r.d(n, o, function (e) {
                return t[e];
              }.bind(null, o));
            }
            return n;
          }, r.n = function (t) {
            var e = t && t.__esModule ? function () {
              return t.default;
            } : function () {
              return t;
            };
            return r.d(e, "a", e), e;
          }, r.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
          }, r.p = "", r(r.s = 0);
        }([function (t, e, r) {
          "use strict";

          (function (t) {
            Object.defineProperty(e, "__esModule", {
              value: !0
            });

            var n = r(6),
                o = n.__importDefault(r(7));

            function i(t) {
              return t.toString("hex");
            }

            function u(e) {
              return new t(e, "hex");
            }

            function a(t) {
              for (var e = new Uint8Array(t), r = [], n = 0; n < e.length;) {
                var o = e[n];
                o < 128 ? (r.push(String.fromCharCode(o)), n++) : o > 191 && o < 224 ? (r.push(String.fromCharCode((31 & o) << 6 | 63 & e[n + 1])), n += 2) : (r.push(String.fromCharCode((15 & o) << 12 | (63 & e[n + 1]) << 6 | 63 & e[n + 2])), n += 3);
              }

              return r.join("");
            }

            function s(t) {
              var e = [],
                  r = 0;

              for (t = encodeURI(t); r < t.length;) {
                var n = t.charCodeAt(r++);
                37 === n ? (e.push(parseInt(t.substr(r, 2), 16)), r += 2) : e.push(n);
              }

              return new Uint8Array(e).buffer;
            }

            function f(t) {
              for (var e = new Uint8Array(t), r = [], n = 0; n < e.length; n++) {
                var o = e[n];
                r.push("0123456789abcdef"[(240 & o) >> 4] + "0123456789abcdef"[15 & o]);
              }

              return r.join("");
            }

            function c(t) {
              for (var e = [], r = 0; r < t.length; r += 2) {
                e.push(parseInt(t.substr(r, 2), 16));
              }

              return new Uint8Array(e).buffer;
            }

            e.convertArrayBufferToBuffer = function (t) {
              return u(f(t));
            }, e.convertBufferToArrayBuffer = function (t) {
              return c(i(t));
            }, e.convertUtf8ToBuffer = function (e) {
              return new t(e, "utf8");
            }, e.convertBufferToUtf8 = function (t) {
              return t.toString("utf8");
            }, e.convertBufferToHex = i, e.convertHexToBuffer = u, e.concatBuffers = function () {
              for (var t = [], e = 0; e < arguments.length; e++) {
                t[e] = arguments[e];
              }

              return u(t.map(function (t) {
                return i(t);
              }).join(""));
            }, e.concatArrayBuffers = function () {
              for (var t = [], e = 0; e < arguments.length; e++) {
                t[e] = arguments[e];
              }

              return c(t.map(function (t) {
                return f(t);
              }).join(""));
            }, e.convertArrayBufferToUtf8 = a, e.convertUtf8ToArrayBuffer = s, e.convertArrayBufferToHex = f, e.convertHexToArrayBuffer = c, e.convertUtf8ToHex = function (t) {
              return f(s(t));
            }, e.convertHexToUtf8 = function (t) {
              return a(c(t));
            }, e.payloadId = function () {
              return new Date().getTime() * Math.pow(10, 3) + Math.floor(Math.random() * Math.pow(10, 3));
            }, e.uuid = function () {
              return function (t, e) {
                for (e = t = ""; t++ < 36; e += 51 * t & 52 ? (15 ^ t ? 8 ^ Math.random() * (20 ^ t ? 16 : 4) : 4).toString(16) : "-") {
                  ;
                }

                return e;
              }();
            }, e.isHexStrict = function (t) {
              return ("string" == typeof t || o.default(t)) && /^(-)?0x[0-9a-f]*$/i.test(t);
            }, e.getMeta = function () {
              if ("undefined" == typeof window || "undefined" == typeof document || void 0 === window.location) return null;

              function t() {
                for (var t = [], e = 0; e < arguments.length; e++) {
                  t[e] = arguments[e];
                }

                for (var r = document.getElementsByTagName("meta"), n = function n(e) {
                  var n = r[e],
                      o = ["itemprop", "property", "name"].map(function (t) {
                    return n.getAttribute(t);
                  }).filter(function (e) {
                    e && t.includes(e);
                  });

                  if (o.length && o) {
                    var i = n.getAttribute("content");
                    if (i) return {
                      value: i
                    };
                  }
                }, o = 0; o < r.length; o++) {
                  var i = n(o);
                  if ("object" == typeof i) return i.value;
                }

                return "";
              }

              var e = function () {
                var e = t("name", "og:site_name", "og:title", "twitter:title");
                return e || (e = document.title), e;
              }();

              return {
                description: t("description", "og:description", "twitter:description", "keywords"),
                url: window.location.origin,
                icons: function () {
                  for (var t = document.getElementsByTagName("link"), e = [], r = 0; r < t.length; r++) {
                    var n = t[r],
                        o = n.getAttribute("rel");

                    if (o && o.toLowerCase().indexOf("icon") > -1) {
                      var i = n.getAttribute("href");
                      if (i) if (-1 === i.toLowerCase().indexOf("https:") && -1 === i.toLowerCase().indexOf("http:") && 0 !== i.indexOf("//")) {
                        var u = window.location.protocol + "//" + window.location.host;
                        if (0 === i.indexOf("/")) u += i;else {
                          var a = window.location.pathname.split("/");
                          a.pop(), u += a.join("/") + "/" + i;
                        }
                        e.push(u);
                      } else if (0 === i.indexOf("//")) {
                        var s = window.location.protocol + i;
                        e.push(s);
                      } else e.push(i);
                    }
                  }

                  return e;
                }(),
                name: e
              };
            }, e.parseWalletConnectUri = function (t) {
              var e = t.indexOf(":"),
                  r = -1 !== t.indexOf("?") ? t.indexOf("?") : void 0,
                  o = t.substring(0, e),
                  i = function (t) {
                var e = t.split("@");
                return {
                  handshakeTopic: e[0],
                  version: parseInt(e[1], 10)
                };
              }(t.substring(e + 1, r)),
                  u = function (t) {
                for (var e = {}, r = ("?" === t[0] ? t.substr(1) : t).split("&"), n = 0; n < r.length; n++) {
                  var o = r[n].match(/\w+(?==)/i) || [],
                      i = r[n].match(/=.+/i) || [];
                  o[0] && (e[decodeURIComponent(o[0])] = decodeURIComponent(i[0].substr(1)));
                }

                return {
                  key: e.key || "",
                  bridge: e.bridge || ""
                };
              }(void 0 !== r ? t.substr(r) : "");

              return n.__assign({
                protocol: o
              }, i, u);
            }, e.promisify = function (t, e) {
              var r = this;
              return function () {
                for (var o = [], i = 0; i < arguments.length; i++) {
                  o[i] = arguments[i];
                }

                return n.__awaiter(r, void 0, void 0, function () {
                  return n.__generator(this, function (r) {
                    return [2, new Promise(function (r, i) {
                      t.apply(e, n.__spread(o, [function (t, e) {
                        null == t && i(t), r(e);
                      }]));
                    })];
                  });
                });
              };
            }, e.formatRpcError = function (t) {
              var e = -32e3;
              if (t && !t.code) switch (t.message) {
                case "Parse error":
                  e = -32700;
                  break;

                case "Invalid request":
                  e = -32600;
                  break;

                case "Method not found":
                  e = -32601;
                  break;

                case "Invalid params":
                  e = -32602;
                  break;

                case "Internal error":
                  e = -32603;
                  break;

                default:
                  e = -32e3;
              }
              return {
                code: e,
                message: t.message
              };
            };
          }).call(this, r(1).Buffer);
        }, function (t, e, r) {
          "use strict";

          (function (t) {
            /*!
             * The buffer module from node.js, for the browser.
             *
             * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
             * @license  MIT
             */
            var n = r(3),
                o = r(4),
                i = r(5);

            function u() {
              return s.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
            }

            function a(t, e) {
              if (u() < e) throw new RangeError("Invalid typed array length");
              return s.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = s.prototype : (null === t && (t = new s(e)), t.length = e), t;
            }

            function s(t, e, r) {
              if (!(s.TYPED_ARRAY_SUPPORT || this instanceof s)) return new s(t, e, r);

              if ("number" == typeof t) {
                if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
                return h(this, t);
              }

              return f(this, t, e, r);
            }

            function f(t, e, r, n) {
              if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
              return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
                if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
                if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
                return e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n), s.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = s.prototype : t = l(t, e), t;
              }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
                if ("string" == typeof r && "" !== r || (r = "utf8"), !s.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
                var n = 0 | d(e, r),
                    o = (t = a(t, n)).write(e, r);
                return o !== n && (t = t.slice(0, o)), t;
              }(t, e, r) : function (t, e) {
                if (s.isBuffer(e)) {
                  var r = 0 | p(e.length);
                  return 0 === (t = a(t, r)).length ? t : (e.copy(t, 0, 0, r), t);
                }

                if (e) {
                  if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? a(t, 0) : l(t, e);
                  if ("Buffer" === e.type && i(e.data)) return l(t, e.data);
                }

                var n;
                throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
              }(t, e);
            }

            function c(t) {
              if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
              if (t < 0) throw new RangeError('"size" argument must not be negative');
            }

            function h(t, e) {
              if (c(e), t = a(t, e < 0 ? 0 : 0 | p(e)), !s.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
                t[r] = 0;
              }
              return t;
            }

            function l(t, e) {
              var r = e.length < 0 ? 0 : 0 | p(e.length);
              t = a(t, r);

              for (var n = 0; n < r; n += 1) {
                t[n] = 255 & e[n];
              }

              return t;
            }

            function p(t) {
              if (t >= u()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + u().toString(16) + " bytes");
              return 0 | t;
            }

            function d(t, e) {
              if (s.isBuffer(t)) return t.length;
              if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
              "string" != typeof t && (t = "" + t);
              var r = t.length;
              if (0 === r) return 0;

              for (var n = !1;;) {
                switch (e) {
                  case "ascii":
                  case "latin1":
                  case "binary":
                    return r;

                  case "utf8":
                  case "utf-8":
                  case void 0:
                    return N(t).length;

                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return 2 * r;

                  case "hex":
                    return r >>> 1;

                  case "base64":
                    return q(t).length;

                  default:
                    if (n) return N(t).length;
                    e = ("" + e).toLowerCase(), n = !0;
                }
              }
            }

            function y(t, e, r) {
              var n = t[e];
              t[e] = t[r], t[r] = n;
            }

            function g(t, e, r, n, o) {
              if (0 === t.length) return -1;

              if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = o ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
                if (o) return -1;
                r = t.length - 1;
              } else if (r < 0) {
                if (!o) return -1;
                r = 0;
              }

              if ("string" == typeof e && (e = s.from(e, n)), s.isBuffer(e)) return 0 === e.length ? -1 : v(t, e, r, n, o);
              if ("number" == typeof e) return e &= 255, s.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : v(t, [e], r, n, o);
              throw new TypeError("val must be string, number or Buffer");
            }

            function v(t, e, r, n, o) {
              var i,
                  u = 1,
                  a = t.length,
                  s = e.length;

              if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                if (t.length < 2 || e.length < 2) return -1;
                u = 2, a /= 2, s /= 2, r /= 2;
              }

              function f(t, e) {
                return 1 === u ? t[e] : t.readUInt16BE(e * u);
              }

              if (o) {
                var c = -1;

                for (i = r; i < a; i++) {
                  if (f(t, i) === f(e, -1 === c ? 0 : i - c)) {
                    if (-1 === c && (c = i), i - c + 1 === s) return c * u;
                  } else -1 !== c && (i -= i - c), c = -1;
                }
              } else for (r + s > a && (r = a - s), i = r; i >= 0; i--) {
                for (var h = !0, l = 0; l < s; l++) {
                  if (f(t, i + l) !== f(e, l)) {
                    h = !1;
                    break;
                  }
                }

                if (h) return i;
              }

              return -1;
            }

            function _(t, e, r, n) {
              r = Number(r) || 0;
              var o = t.length - r;
              n ? (n = Number(n)) > o && (n = o) : n = o;
              var i = e.length;
              if (i % 2 != 0) throw new TypeError("Invalid hex string");
              n > i / 2 && (n = i / 2);

              for (var u = 0; u < n; ++u) {
                var a = parseInt(e.substr(2 * u, 2), 16);
                if (isNaN(a)) return u;
                t[r + u] = a;
              }

              return u;
            }

            function w(t, e, r, n) {
              return H(N(e, t.length - r), t, r, n);
            }

            function b(t, e, r, n) {
              return H(function (t) {
                for (var e = [], r = 0; r < t.length; ++r) {
                  e.push(255 & t.charCodeAt(r));
                }

                return e;
              }(e), t, r, n);
            }

            function m(t, e, r, n) {
              return b(t, e, r, n);
            }

            function S(t, e, r, n) {
              return H(q(e), t, r, n);
            }

            function A(t, e, r, n) {
              return H(function (t, e) {
                for (var r, n, o, i = [], u = 0; u < t.length && !((e -= 2) < 0); ++u) {
                  r = t.charCodeAt(u), n = r >> 8, o = r % 256, i.push(o), i.push(n);
                }

                return i;
              }(e, t.length - r), t, r, n);
            }

            function P(t, e, r) {
              return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
            }

            function E(t, e, r) {
              r = Math.min(t.length, r);

              for (var n = [], o = e; o < r;) {
                var i,
                    u,
                    a,
                    s,
                    f = t[o],
                    c = null,
                    h = f > 239 ? 4 : f > 223 ? 3 : f > 191 ? 2 : 1;
                if (o + h <= r) switch (h) {
                  case 1:
                    f < 128 && (c = f);
                    break;

                  case 2:
                    128 == (192 & (i = t[o + 1])) && (s = (31 & f) << 6 | 63 & i) > 127 && (c = s);
                    break;

                  case 3:
                    i = t[o + 1], u = t[o + 2], 128 == (192 & i) && 128 == (192 & u) && (s = (15 & f) << 12 | (63 & i) << 6 | 63 & u) > 2047 && (s < 55296 || s > 57343) && (c = s);
                    break;

                  case 4:
                    i = t[o + 1], u = t[o + 2], a = t[o + 3], 128 == (192 & i) && 128 == (192 & u) && 128 == (192 & a) && (s = (15 & f) << 18 | (63 & i) << 12 | (63 & u) << 6 | 63 & a) > 65535 && s < 1114112 && (c = s);
                }
                null === c ? (c = 65533, h = 1) : c > 65535 && (c -= 65536, n.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n.push(c), o += h;
              }

              return function (t) {
                var e = t.length;
                if (e <= R) return String.fromCharCode.apply(String, t);

                for (var r = "", n = 0; n < e;) {
                  r += String.fromCharCode.apply(String, t.slice(n, n += R));
                }

                return r;
              }(n);
            }

            e.Buffer = s, e.SlowBuffer = function (t) {
              return +t != t && (t = 0), s.alloc(+t);
            }, e.INSPECT_MAX_BYTES = 50, s.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
              try {
                var t = new Uint8Array(1);
                return t.__proto__ = {
                  __proto__: Uint8Array.prototype,
                  foo: function foo() {
                    return 42;
                  }
                }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
              } catch (t) {
                return !1;
              }
            }(), e.kMaxLength = u(), s.poolSize = 8192, s._augment = function (t) {
              return t.__proto__ = s.prototype, t;
            }, s.from = function (t, e, r) {
              return f(null, t, e, r);
            }, s.TYPED_ARRAY_SUPPORT && (s.prototype.__proto__ = Uint8Array.prototype, s.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && s[Symbol.species] === s && Object.defineProperty(s, Symbol.species, {
              value: null,
              configurable: !0
            })), s.alloc = function (t, e, r) {
              return function (t, e, r, n) {
                return c(e), e <= 0 ? a(t, e) : void 0 !== r ? "string" == typeof n ? a(t, e).fill(r, n) : a(t, e).fill(r) : a(t, e);
              }(null, t, e, r);
            }, s.allocUnsafe = function (t) {
              return h(null, t);
            }, s.allocUnsafeSlow = function (t) {
              return h(null, t);
            }, s.isBuffer = function (t) {
              return !(null == t || !t._isBuffer);
            }, s.compare = function (t, e) {
              if (!s.isBuffer(t) || !s.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
              if (t === e) return 0;

              for (var r = t.length, n = e.length, o = 0, i = Math.min(r, n); o < i; ++o) {
                if (t[o] !== e[o]) {
                  r = t[o], n = e[o];
                  break;
                }
              }

              return r < n ? -1 : n < r ? 1 : 0;
            }, s.isEncoding = function (t) {
              switch (String(t).toLowerCase()) {
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "latin1":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return !0;

                default:
                  return !1;
              }
            }, s.concat = function (t, e) {
              if (!i(t)) throw new TypeError('"list" argument must be an Array of Buffers');
              if (0 === t.length) return s.alloc(0);
              var r;
              if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
                e += t[r].length;
              }
              var n = s.allocUnsafe(e),
                  o = 0;

              for (r = 0; r < t.length; ++r) {
                var u = t[r];
                if (!s.isBuffer(u)) throw new TypeError('"list" argument must be an Array of Buffers');
                u.copy(n, o), o += u.length;
              }

              return n;
            }, s.byteLength = d, s.prototype._isBuffer = !0, s.prototype.swap16 = function () {
              var t = this.length;
              if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

              for (var e = 0; e < t; e += 2) {
                y(this, e, e + 1);
              }

              return this;
            }, s.prototype.swap32 = function () {
              var t = this.length;
              if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

              for (var e = 0; e < t; e += 4) {
                y(this, e, e + 3), y(this, e + 1, e + 2);
              }

              return this;
            }, s.prototype.swap64 = function () {
              var t = this.length;
              if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

              for (var e = 0; e < t; e += 8) {
                y(this, e, e + 7), y(this, e + 1, e + 6), y(this, e + 2, e + 5), y(this, e + 3, e + 4);
              }

              return this;
            }, s.prototype.toString = function () {
              var t = 0 | this.length;
              return 0 === t ? "" : 0 === arguments.length ? E(this, 0, t) : function (t, e, r) {
                var n = !1;
                if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
                if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                if ((r >>>= 0) <= (e >>>= 0)) return "";

                for (t || (t = "utf8");;) {
                  switch (t) {
                    case "hex":
                      return I(this, e, r);

                    case "utf8":
                    case "utf-8":
                      return E(this, e, r);

                    case "ascii":
                      return O(this, e, r);

                    case "latin1":
                    case "binary":
                      return T(this, e, r);

                    case "base64":
                      return P(this, e, r);

                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                      return x(this, e, r);

                    default:
                      if (n) throw new TypeError("Unknown encoding: " + t);
                      t = (t + "").toLowerCase(), n = !0;
                  }
                }
              }.apply(this, arguments);
            }, s.prototype.equals = function (t) {
              if (!s.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
              return this === t || 0 === s.compare(this, t);
            }, s.prototype.inspect = function () {
              var t = "",
                  r = e.INSPECT_MAX_BYTES;
              return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
            }, s.prototype.compare = function (t, e, r, n, o) {
              if (!s.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
              if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === o && (o = this.length), e < 0 || r > t.length || n < 0 || o > this.length) throw new RangeError("out of range index");
              if (n >= o && e >= r) return 0;
              if (n >= o) return -1;
              if (e >= r) return 1;
              if (this === t) return 0;

              for (var i = (o >>>= 0) - (n >>>= 0), u = (r >>>= 0) - (e >>>= 0), a = Math.min(i, u), f = this.slice(n, o), c = t.slice(e, r), h = 0; h < a; ++h) {
                if (f[h] !== c[h]) {
                  i = f[h], u = c[h];
                  break;
                }
              }

              return i < u ? -1 : u < i ? 1 : 0;
            }, s.prototype.includes = function (t, e, r) {
              return -1 !== this.indexOf(t, e, r);
            }, s.prototype.indexOf = function (t, e, r) {
              return g(this, t, e, r, !0);
            }, s.prototype.lastIndexOf = function (t, e, r) {
              return g(this, t, e, r, !1);
            }, s.prototype.write = function (t, e, r, n) {
              if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
                if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
              }
              var o = this.length - e;
              if ((void 0 === r || r > o) && (r = o), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
              n || (n = "utf8");

              for (var i = !1;;) {
                switch (n) {
                  case "hex":
                    return _(this, t, e, r);

                  case "utf8":
                  case "utf-8":
                    return w(this, t, e, r);

                  case "ascii":
                    return b(this, t, e, r);

                  case "latin1":
                  case "binary":
                    return m(this, t, e, r);

                  case "base64":
                    return S(this, t, e, r);

                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return A(this, t, e, r);

                  default:
                    if (i) throw new TypeError("Unknown encoding: " + n);
                    n = ("" + n).toLowerCase(), i = !0;
                }
              }
            }, s.prototype.toJSON = function () {
              return {
                type: "Buffer",
                data: Array.prototype.slice.call(this._arr || this, 0)
              };
            };
            var R = 4096;

            function O(t, e, r) {
              var n = "";
              r = Math.min(t.length, r);

              for (var o = e; o < r; ++o) {
                n += String.fromCharCode(127 & t[o]);
              }

              return n;
            }

            function T(t, e, r) {
              var n = "";
              r = Math.min(t.length, r);

              for (var o = e; o < r; ++o) {
                n += String.fromCharCode(t[o]);
              }

              return n;
            }

            function I(t, e, r) {
              var n = t.length;
              (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

              for (var o = "", i = e; i < r; ++i) {
                o += L(t[i]);
              }

              return o;
            }

            function x(t, e, r) {
              for (var n = t.slice(e, r), o = "", i = 0; i < n.length; i += 2) {
                o += String.fromCharCode(n[i] + 256 * n[i + 1]);
              }

              return o;
            }

            function B(t, e, r) {
              if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
              if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
            }

            function U(t, e, r, n, o, i) {
              if (!s.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
              if (e > o || e < i) throw new RangeError('"value" argument is out of bounds');
              if (r + n > t.length) throw new RangeError("Index out of range");
            }

            function j(t, e, r, n) {
              e < 0 && (e = 65535 + e + 1);

              for (var o = 0, i = Math.min(t.length - r, 2); o < i; ++o) {
                t[r + o] = (e & 255 << 8 * (n ? o : 1 - o)) >>> 8 * (n ? o : 1 - o);
              }
            }

            function M(t, e, r, n) {
              e < 0 && (e = 4294967295 + e + 1);

              for (var o = 0, i = Math.min(t.length - r, 4); o < i; ++o) {
                t[r + o] = e >>> 8 * (n ? o : 3 - o) & 255;
              }
            }

            function k(t, e, r, n, o, i) {
              if (r + n > t.length) throw new RangeError("Index out of range");
              if (r < 0) throw new RangeError("Index out of range");
            }

            function C(t, e, r, n, i) {
              return i || k(t, 0, r, 4), o.write(t, e, r, n, 23, 4), r + 4;
            }

            function Y(t, e, r, n, i) {
              return i || k(t, 0, r, 8), o.write(t, e, r, n, 52, 8), r + 8;
            }

            s.prototype.slice = function (t, e) {
              var r,
                  n = this.length;
              if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), s.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = s.prototype;else {
                var o = e - t;
                r = new s(o, void 0);

                for (var i = 0; i < o; ++i) {
                  r[i] = this[i + t];
                }
              }
              return r;
            }, s.prototype.readUIntLE = function (t, e, r) {
              t |= 0, e |= 0, r || B(t, e, this.length);

              for (var n = this[t], o = 1, i = 0; ++i < e && (o *= 256);) {
                n += this[t + i] * o;
              }

              return n;
            }, s.prototype.readUIntBE = function (t, e, r) {
              t |= 0, e |= 0, r || B(t, e, this.length);

              for (var n = this[t + --e], o = 1; e > 0 && (o *= 256);) {
                n += this[t + --e] * o;
              }

              return n;
            }, s.prototype.readUInt8 = function (t, e) {
              return e || B(t, 1, this.length), this[t];
            }, s.prototype.readUInt16LE = function (t, e) {
              return e || B(t, 2, this.length), this[t] | this[t + 1] << 8;
            }, s.prototype.readUInt16BE = function (t, e) {
              return e || B(t, 2, this.length), this[t] << 8 | this[t + 1];
            }, s.prototype.readUInt32LE = function (t, e) {
              return e || B(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
            }, s.prototype.readUInt32BE = function (t, e) {
              return e || B(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
            }, s.prototype.readIntLE = function (t, e, r) {
              t |= 0, e |= 0, r || B(t, e, this.length);

              for (var n = this[t], o = 1, i = 0; ++i < e && (o *= 256);) {
                n += this[t + i] * o;
              }

              return n >= (o *= 128) && (n -= Math.pow(2, 8 * e)), n;
            }, s.prototype.readIntBE = function (t, e, r) {
              t |= 0, e |= 0, r || B(t, e, this.length);

              for (var n = e, o = 1, i = this[t + --n]; n > 0 && (o *= 256);) {
                i += this[t + --n] * o;
              }

              return i >= (o *= 128) && (i -= Math.pow(2, 8 * e)), i;
            }, s.prototype.readInt8 = function (t, e) {
              return e || B(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
            }, s.prototype.readInt16LE = function (t, e) {
              e || B(t, 2, this.length);
              var r = this[t] | this[t + 1] << 8;
              return 32768 & r ? 4294901760 | r : r;
            }, s.prototype.readInt16BE = function (t, e) {
              e || B(t, 2, this.length);
              var r = this[t + 1] | this[t] << 8;
              return 32768 & r ? 4294901760 | r : r;
            }, s.prototype.readInt32LE = function (t, e) {
              return e || B(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
            }, s.prototype.readInt32BE = function (t, e) {
              return e || B(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
            }, s.prototype.readFloatLE = function (t, e) {
              return e || B(t, 4, this.length), o.read(this, t, !0, 23, 4);
            }, s.prototype.readFloatBE = function (t, e) {
              return e || B(t, 4, this.length), o.read(this, t, !1, 23, 4);
            }, s.prototype.readDoubleLE = function (t, e) {
              return e || B(t, 8, this.length), o.read(this, t, !0, 52, 8);
            }, s.prototype.readDoubleBE = function (t, e) {
              return e || B(t, 8, this.length), o.read(this, t, !1, 52, 8);
            }, s.prototype.writeUIntLE = function (t, e, r, n) {
              t = +t, e |= 0, r |= 0, n || U(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
              var o = 1,
                  i = 0;

              for (this[e] = 255 & t; ++i < r && (o *= 256);) {
                this[e + i] = t / o & 255;
              }

              return e + r;
            }, s.prototype.writeUIntBE = function (t, e, r, n) {
              t = +t, e |= 0, r |= 0, n || U(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
              var o = r - 1,
                  i = 1;

              for (this[e + o] = 255 & t; --o >= 0 && (i *= 256);) {
                this[e + o] = t / i & 255;
              }

              return e + r;
            }, s.prototype.writeUInt8 = function (t, e, r) {
              return t = +t, e |= 0, r || U(this, t, e, 1, 255, 0), s.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
            }, s.prototype.writeUInt16LE = function (t, e, r) {
              return t = +t, e |= 0, r || U(this, t, e, 2, 65535, 0), s.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : j(this, t, e, !0), e + 2;
            }, s.prototype.writeUInt16BE = function (t, e, r) {
              return t = +t, e |= 0, r || U(this, t, e, 2, 65535, 0), s.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : j(this, t, e, !1), e + 2;
            }, s.prototype.writeUInt32LE = function (t, e, r) {
              return t = +t, e |= 0, r || U(this, t, e, 4, 4294967295, 0), s.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : M(this, t, e, !0), e + 4;
            }, s.prototype.writeUInt32BE = function (t, e, r) {
              return t = +t, e |= 0, r || U(this, t, e, 4, 4294967295, 0), s.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : M(this, t, e, !1), e + 4;
            }, s.prototype.writeIntLE = function (t, e, r, n) {
              if (t = +t, e |= 0, !n) {
                var o = Math.pow(2, 8 * r - 1);
                U(this, t, e, r, o - 1, -o);
              }

              var i = 0,
                  u = 1,
                  a = 0;

              for (this[e] = 255 & t; ++i < r && (u *= 256);) {
                t < 0 && 0 === a && 0 !== this[e + i - 1] && (a = 1), this[e + i] = (t / u >> 0) - a & 255;
              }

              return e + r;
            }, s.prototype.writeIntBE = function (t, e, r, n) {
              if (t = +t, e |= 0, !n) {
                var o = Math.pow(2, 8 * r - 1);
                U(this, t, e, r, o - 1, -o);
              }

              var i = r - 1,
                  u = 1,
                  a = 0;

              for (this[e + i] = 255 & t; --i >= 0 && (u *= 256);) {
                t < 0 && 0 === a && 0 !== this[e + i + 1] && (a = 1), this[e + i] = (t / u >> 0) - a & 255;
              }

              return e + r;
            }, s.prototype.writeInt8 = function (t, e, r) {
              return t = +t, e |= 0, r || U(this, t, e, 1, 127, -128), s.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
            }, s.prototype.writeInt16LE = function (t, e, r) {
              return t = +t, e |= 0, r || U(this, t, e, 2, 32767, -32768), s.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : j(this, t, e, !0), e + 2;
            }, s.prototype.writeInt16BE = function (t, e, r) {
              return t = +t, e |= 0, r || U(this, t, e, 2, 32767, -32768), s.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : j(this, t, e, !1), e + 2;
            }, s.prototype.writeInt32LE = function (t, e, r) {
              return t = +t, e |= 0, r || U(this, t, e, 4, 2147483647, -2147483648), s.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : M(this, t, e, !0), e + 4;
            }, s.prototype.writeInt32BE = function (t, e, r) {
              return t = +t, e |= 0, r || U(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), s.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : M(this, t, e, !1), e + 4;
            }, s.prototype.writeFloatLE = function (t, e, r) {
              return C(this, t, e, !0, r);
            }, s.prototype.writeFloatBE = function (t, e, r) {
              return C(this, t, e, !1, r);
            }, s.prototype.writeDoubleLE = function (t, e, r) {
              return Y(this, t, e, !0, r);
            }, s.prototype.writeDoubleBE = function (t, e, r) {
              return Y(this, t, e, !1, r);
            }, s.prototype.copy = function (t, e, r, n) {
              if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
              if (0 === t.length || 0 === this.length) return 0;
              if (e < 0) throw new RangeError("targetStart out of bounds");
              if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
              if (n < 0) throw new RangeError("sourceEnd out of bounds");
              n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
              var o,
                  i = n - r;
              if (this === t && r < e && e < n) for (o = i - 1; o >= 0; --o) {
                t[o + e] = this[o + r];
              } else if (i < 1e3 || !s.TYPED_ARRAY_SUPPORT) for (o = 0; o < i; ++o) {
                t[o + e] = this[o + r];
              } else Uint8Array.prototype.set.call(t, this.subarray(r, r + i), e);
              return i;
            }, s.prototype.fill = function (t, e, r, n) {
              if ("string" == typeof t) {
                if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
                  var o = t.charCodeAt(0);
                  o < 256 && (t = o);
                }

                if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                if ("string" == typeof n && !s.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
              } else "number" == typeof t && (t &= 255);

              if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
              if (r <= e) return this;
              var i;
              if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (i = e; i < r; ++i) {
                this[i] = t;
              } else {
                var u = s.isBuffer(t) ? t : N(new s(t, n).toString()),
                    a = u.length;

                for (i = 0; i < r - e; ++i) {
                  this[i + e] = u[i % a];
                }
              }
              return this;
            };
            var D = /[^+\/0-9A-Za-z-_]/g;

            function L(t) {
              return t < 16 ? "0" + t.toString(16) : t.toString(16);
            }

            function N(t, e) {
              var r;
              e = e || 1 / 0;

              for (var n = t.length, o = null, i = [], u = 0; u < n; ++u) {
                if ((r = t.charCodeAt(u)) > 55295 && r < 57344) {
                  if (!o) {
                    if (r > 56319) {
                      (e -= 3) > -1 && i.push(239, 191, 189);
                      continue;
                    }

                    if (u + 1 === n) {
                      (e -= 3) > -1 && i.push(239, 191, 189);
                      continue;
                    }

                    o = r;
                    continue;
                  }

                  if (r < 56320) {
                    (e -= 3) > -1 && i.push(239, 191, 189), o = r;
                    continue;
                  }

                  r = 65536 + (o - 55296 << 10 | r - 56320);
                } else o && (e -= 3) > -1 && i.push(239, 191, 189);

                if (o = null, r < 128) {
                  if ((e -= 1) < 0) break;
                  i.push(r);
                } else if (r < 2048) {
                  if ((e -= 2) < 0) break;
                  i.push(r >> 6 | 192, 63 & r | 128);
                } else if (r < 65536) {
                  if ((e -= 3) < 0) break;
                  i.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                } else {
                  if (!(r < 1114112)) throw new Error("Invalid code point");
                  if ((e -= 4) < 0) break;
                  i.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                }
              }

              return i;
            }

            function q(t) {
              return n.toByteArray(function (t) {
                if ((t = function (t) {
                  return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
                }(t).replace(D, "")).length < 2) return "";

                for (; t.length % 4 != 0;) {
                  t += "=";
                }

                return t;
              }(t));
            }

            function H(t, e, r, n) {
              for (var o = 0; o < n && !(o + r >= e.length || o >= t.length); ++o) {
                e[o + r] = t[o];
              }

              return o;
            }
          }).call(this, r(2));
        }, function (t, e) {
          var r;

          r = function () {
            return this;
          }();

          try {
            r = r || new Function("return this")();
          } catch (t) {
            "object" == typeof window && (r = window);
          }

          t.exports = r;
        }, function (t, e, r) {
          "use strict";

          e.byteLength = function (t) {
            var e = f(t),
                r = e[0],
                n = e[1];
            return 3 * (r + n) / 4 - n;
          }, e.toByteArray = function (t) {
            for (var e, r = f(t), n = r[0], u = r[1], a = new i(NaN), s = 0, c = u > 0 ? n - 4 : n, h = 0; h < c; h += 4) {
              e = o[t.charCodeAt(h)] << 18 | o[t.charCodeAt(h + 1)] << 12 | o[t.charCodeAt(h + 2)] << 6 | o[t.charCodeAt(h + 3)], a[s++] = e >> 16 & 255, a[s++] = e >> 8 & 255, a[s++] = 255 & e;
            }

            return 2 === u && (e = o[t.charCodeAt(h)] << 2 | o[t.charCodeAt(h + 1)] >> 4, a[s++] = 255 & e), 1 === u && (e = o[t.charCodeAt(h)] << 10 | o[t.charCodeAt(h + 1)] << 4 | o[t.charCodeAt(h + 2)] >> 2, a[s++] = e >> 8 & 255, a[s++] = 255 & e), a;
          }, e.fromByteArray = function (t) {
            for (var e, r = t.length, o = r % 3, i = [], u = 0, a = r - o; u < a; u += 16383) {
              i.push(c(t, u, u + 16383 > a ? a : u + 16383));
            }

            return 1 === o ? (e = t[r - 1], i.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === o && (e = (t[r - 2] << 8) + t[r - 1], i.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "=")), i.join("");
          };

          for (var n = [], o = [], i = "undefined" != typeof Uint8Array ? Uint8Array : Array, u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, s = u.length; a < s; ++a) {
            n[a] = u[a], o[u.charCodeAt(a)] = a;
          }

          function f(t) {
            var e = t.length;
            if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
            var r = t.indexOf("=");
            return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
          }

          function c(t, e, r) {
            for (var o, i, u = [], a = e; a < r; a += 3) {
              o = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (255 & t[a + 2]), u.push(n[(i = o) >> 18 & 63] + n[i >> 12 & 63] + n[i >> 6 & 63] + n[63 & i]);
            }

            return u.join("");
          }

          o["-".charCodeAt(0)] = 62, o["_".charCodeAt(0)] = 63;
        }, function (t, e) {
          e.read = function (t, e, r, n, o) {
            var i,
                u,
                a = 8 * o - n - 1,
                s = (1 << a) - 1,
                f = s >> 1,
                c = -7,
                h = r ? o - 1 : 0,
                l = r ? -1 : 1,
                p = t[e + h];

            for (h += l, i = p & (1 << -c) - 1, p >>= -c, c += a; c > 0; i = 256 * i + t[e + h], h += l, c -= 8) {
              ;
            }

            for (u = i & (1 << -c) - 1, i >>= -c, c += n; c > 0; u = 256 * u + t[e + h], h += l, c -= 8) {
              ;
            }

            if (0 === i) i = 1 - f;else {
              if (i === s) return u ? NaN : 1 / 0 * (p ? -1 : 1);
              u += Math.pow(2, n), i -= f;
            }
            return (p ? -1 : 1) * u * Math.pow(2, i - n);
          }, e.write = function (t, e, r, n, o, i) {
            var u,
                a,
                s,
                f = 8 * i - o - 1,
                c = (1 << f) - 1,
                h = c >> 1,
                l = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
                p = n ? 0 : i - 1,
                d = n ? 1 : -1,
                y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

            for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, u = c) : (u = Math.floor(Math.log(e) / Math.LN2), e * (s = Math.pow(2, -u)) < 1 && (u--, s *= 2), (e += u + h >= 1 ? l / s : l * Math.pow(2, 1 - h)) * s >= 2 && (u++, s /= 2), u + h >= c ? (a = 0, u = c) : u + h >= 1 ? (a = (e * s - 1) * Math.pow(2, o), u += h) : (a = e * Math.pow(2, h - 1) * Math.pow(2, o), u = 0)); o >= 8; t[r + p] = 255 & a, p += d, a /= 256, o -= 8) {
              ;
            }

            for (u = u << o | a, f += o; f > 0; t[r + p] = 255 & u, p += d, u /= 256, f -= 8) {
              ;
            }

            t[r + p - d] |= 128 * y;
          };
        }, function (t, e) {
          var r = {}.toString;

          t.exports = Array.isArray || function (t) {
            return "[object Array]" == r.call(t);
          };
        }, function (t, e, r) {
          "use strict";

          r.r(e), r.d(e, "__extends", function () {
            return o;
          }), r.d(e, "__assign", function () {
            return _i4;
          }), r.d(e, "__rest", function () {
            return u;
          }), r.d(e, "__decorate", function () {
            return a;
          }), r.d(e, "__param", function () {
            return s;
          }), r.d(e, "__metadata", function () {
            return f;
          }), r.d(e, "__awaiter", function () {
            return c;
          }), r.d(e, "__generator", function () {
            return h;
          }), r.d(e, "__exportStar", function () {
            return l;
          }), r.d(e, "__values", function () {
            return p;
          }), r.d(e, "__read", function () {
            return d;
          }), r.d(e, "__spread", function () {
            return y;
          }), r.d(e, "__await", function () {
            return g;
          }), r.d(e, "__asyncGenerator", function () {
            return v;
          }), r.d(e, "__asyncDelegator", function () {
            return _;
          }), r.d(e, "__asyncValues", function () {
            return w;
          }), r.d(e, "__makeTemplateObject", function () {
            return b;
          }), r.d(e, "__importStar", function () {
            return m;
          }), r.d(e, "__importDefault", function () {
            return S;
          });
          /*! *****************************************************************************
          Copyright (c) Microsoft Corporation. All rights reserved.
          Licensed under the Apache License, Version 2.0 (the "License"); you may not use
          this file except in compliance with the License. You may obtain a copy of the
          License at http://www.apache.org/licenses/LICENSE-2.0
          
          THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
          KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
          WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
          MERCHANTABLITY OR NON-INFRINGEMENT.
          
          See the Apache Version 2.0 License for specific language governing permissions
          and limitations under the License.
          ***************************************************************************** */

          var _n4 = function n(t, e) {
            return (_n4 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) {
                e.hasOwnProperty(r) && (t[r] = e[r]);
              }
            })(t, e);
          };

          function o(t, e) {
            function r() {
              this.constructor = t;
            }

            _n4(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }

          var _i4 = function i() {
            return (_i4 = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) {
                for (var o in e = arguments[r]) {
                  Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                }
              }

              return t;
            }).apply(this, arguments);
          };

          function u(t, e) {
            var r = {};

            for (var n in t) {
              Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
            }

            if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
              var o = 0;

              for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) {
                e.indexOf(n[o]) < 0 && (r[n[o]] = t[n[o]]);
              }
            }

            return r;
          }

          function a(t, e, r, n) {
            var o,
                i = arguments.length,
                u = i < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
            if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) u = Reflect.decorate(t, e, r, n);else for (var a = t.length - 1; a >= 0; a--) {
              (o = t[a]) && (u = (i < 3 ? o(u) : i > 3 ? o(e, r, u) : o(e, r)) || u);
            }
            return i > 3 && u && Object.defineProperty(e, r, u), u;
          }

          function s(t, e) {
            return function (r, n) {
              e(r, n, t);
            };
          }

          function f(t, e) {
            if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
          }

          function c(t, e, r, n) {
            return new (r || (r = Promise))(function (o, i) {
              function u(t) {
                try {
                  s(n.next(t));
                } catch (t) {
                  i(t);
                }
              }

              function a(t) {
                try {
                  s(n.throw(t));
                } catch (t) {
                  i(t);
                }
              }

              function s(t) {
                t.done ? o(t.value) : new r(function (e) {
                  e(t.value);
                }).then(u, a);
              }

              s((n = n.apply(t, e || [])).next());
            });
          }

          function h(t, e) {
            var r,
                n,
                o,
                i,
                u = {
              label: 0,
              sent: function sent() {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: []
            };
            return i = {
              next: a(0),
              throw: a(1),
              return: a(2)
            }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
              return this;
            }), i;

            function a(i) {
              return function (a) {
                return function (i) {
                  if (r) throw new TypeError("Generator is already executing.");

                  for (; u;) {
                    try {
                      if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                      switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                        case 0:
                        case 1:
                          o = i;
                          break;

                        case 4:
                          return u.label++, {
                            value: i[1],
                            done: !1
                          };

                        case 5:
                          u.label++, n = i[1], i = [0];
                          continue;

                        case 7:
                          i = u.ops.pop(), u.trys.pop();
                          continue;

                        default:
                          if (!(o = (o = u.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                            u = 0;
                            continue;
                          }

                          if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                            u.label = i[1];
                            break;
                          }

                          if (6 === i[0] && u.label < o[1]) {
                            u.label = o[1], o = i;
                            break;
                          }

                          if (o && u.label < o[2]) {
                            u.label = o[2], u.ops.push(i);
                            break;
                          }

                          o[2] && u.ops.pop(), u.trys.pop();
                          continue;
                      }

                      i = e.call(t, u);
                    } catch (t) {
                      i = [6, t], n = 0;
                    } finally {
                      r = o = 0;
                    }
                  }

                  if (5 & i[0]) throw i[1];
                  return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                  };
                }([i, a]);
              };
            }
          }

          function l(t, e) {
            for (var r in t) {
              e.hasOwnProperty(r) || (e[r] = t[r]);
            }
          }

          function p(t) {
            var e = "function" == typeof Symbol && t[Symbol.iterator],
                r = 0;
            return e ? e.call(t) : {
              next: function next() {
                return t && r >= t.length && (t = void 0), {
                  value: t && t[r++],
                  done: !t
                };
              }
            };
          }

          function d(t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
                o,
                i = r.call(t),
                u = [];

            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) {
                u.push(n.value);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }

            return u;
          }

          function y() {
            for (var t = [], e = 0; e < arguments.length; e++) {
              t = t.concat(d(arguments[e]));
            }

            return t;
          }

          function g(t) {
            return this instanceof g ? (this.v = t, this) : new g(t);
          }

          function v(t, e, r) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var n,
                o = r.apply(t, e || []),
                i = [];
            return n = {}, u("next"), u("throw"), u("return"), n[Symbol.asyncIterator] = function () {
              return this;
            }, n;

            function u(t) {
              o[t] && (n[t] = function (e) {
                return new Promise(function (r, n) {
                  i.push([t, e, r, n]) > 1 || a(t, e);
                });
              });
            }

            function a(t, e) {
              try {
                (r = o[t](e)).value instanceof g ? Promise.resolve(r.value.v).then(s, f) : c(i[0][2], r);
              } catch (t) {
                c(i[0][3], t);
              }

              var r;
            }

            function s(t) {
              a("next", t);
            }

            function f(t) {
              a("throw", t);
            }

            function c(t, e) {
              t(e), i.shift(), i.length && a(i[0][0], i[0][1]);
            }
          }

          function _(t) {
            var e, r;
            return e = {}, n("next"), n("throw", function (t) {
              throw t;
            }), n("return"), e[Symbol.iterator] = function () {
              return this;
            }, e;

            function n(n, o) {
              e[n] = t[n] ? function (e) {
                return (r = !r) ? {
                  value: g(t[n](e)),
                  done: "return" === n
                } : o ? o(e) : e;
              } : o;
            }
          }

          function w(t) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var e,
                r = t[Symbol.asyncIterator];
            return r ? r.call(t) : (t = p(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
              return this;
            }, e);

            function n(r) {
              e[r] = t[r] && function (e) {
                return new Promise(function (n, o) {
                  !function (t, e, r, n) {
                    Promise.resolve(n).then(function (e) {
                      t({
                        value: e,
                        done: r
                      });
                    }, e);
                  }(n, o, (e = t[r](e)).done, e.value);
                });
              };
            }
          }

          function b(t, e) {
            return Object.defineProperty ? Object.defineProperty(t, "raw", {
              value: e
            }) : t.raw = e, t;
          }

          function m(t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) {
              Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
            }
            return e.default = t, e;
          }

          function S(t) {
            return t && t.__esModule ? t : {
              default: t
            };
          }
        }, function (t, e) {
          var r = Object.prototype.toString;

          t.exports = function (t) {
            return "number" == typeof t || function (t) {
              return !!t && "object" == typeof t;
            }(t) && "[object Number]" == r.call(t);
          };
        }]);
      }]);
    }, function (t, e, r) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var n = r(0),
          o = r(4),
          i = "AES-CBC",
          u = 256,
          a = "SHA-256";

      function s(t) {
        return n.__awaiter(this, void 0, void 0, function () {
          return n.__generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, window.crypto.subtle.exportKey("raw", t)];

              case 1:
                return [2, e.sent()];
            }
          });
        });
      }

      function f(t, e) {
        return void 0 === e && (e = i), n.__awaiter(this, void 0, void 0, function () {
          var r, o;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return r = e === i ? {
                  length: u,
                  name: i
                } : {
                  hash: {
                    name: a
                  },
                  name: "HMAC"
                }, o = e === i ? ["encrypt", "decrypt"] : ["sign", "verify"], [4, window.crypto.subtle.importKey("raw", t, r, !0, o)];

              case 1:
                return [2, n.sent()];
            }
          });
        });
      }

      function c(t) {
        return n.__awaiter(this, void 0, void 0, function () {
          var e;
          return n.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return e = t || 256, [4, window.crypto.subtle.generateKey({
                  length: e,
                  name: i
                }, !0, ["encrypt", "decrypt"])];

              case 1:
                return [4, s(r.sent())];

              case 2:
                return [2, r.sent()];
            }
          });
        });
      }

      function h(t, e) {
        return n.__awaiter(this, void 0, void 0, function () {
          var r;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, f(e, "HMAC")];

              case 1:
                return r = n.sent(), [4, window.crypto.subtle.sign({
                  length: 256,
                  name: "HMAC"
                }, r, t)];

              case 2:
                return [2, n.sent()];
            }
          });
        });
      }

      function l(t, e) {
        return n.__awaiter(this, void 0, void 0, function () {
          var r, i, u, a, s, f;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return r = o.convertHexToArrayBuffer(t.data), i = o.convertHexToArrayBuffer(t.iv), u = o.convertHexToArrayBuffer(t.hmac), a = o.convertArrayBufferToHex(u), [4, h(o.concatArrayBuffers(r, i), e)];

              case 1:
                return s = n.sent(), f = o.convertArrayBufferToHex(s), a === f ? [2, !0] : [2, !1];
            }
          });
        });
      }

      function p(t, e, r) {
        return n.__awaiter(this, void 0, void 0, function () {
          var o;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, f(e, i)];

              case 1:
                return o = n.sent(), [4, window.crypto.subtle.encrypt({
                  iv: r,
                  name: i
                }, o, t)];

              case 2:
                return [2, n.sent()];
            }
          });
        });
      }

      function d(t, e, r) {
        return n.__awaiter(this, void 0, void 0, function () {
          var o;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, f(e, i)];

              case 1:
                return o = n.sent(), [4, window.crypto.subtle.decrypt({
                  iv: r,
                  name: i
                }, o, t)];

              case 2:
                return [2, n.sent()];
            }
          });
        });
      }

      e.exportKey = s, e.importKey = f, e.generateKey = c, e.createHmac = h, e.verifyHmac = l, e.aesCbcEncrypt = p, e.aesCbcDecrypt = d, e.encrypt = function (t, e) {
        return n.__awaiter(this, void 0, void 0, function () {
          var r, i, u, a, s, f, l;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                if (!e) throw new Error("Missing key: required for encryption");
                return [4, c(128)];

              case 1:
                return r = n.sent(), i = o.convertArrayBufferToHex(r), u = JSON.stringify(t), [4, p(o.convertUtf8ToArrayBuffer(u), e, r)];

              case 2:
                return a = n.sent(), s = o.convertArrayBufferToHex(a), [4, h(o.concatArrayBuffers(a, r), e)];

              case 3:
                return f = n.sent(), l = o.convertArrayBufferToHex(f), [2, {
                  data: s,
                  hmac: l,
                  iv: i
                }];
            }
          });
        });
      }, e.decrypt = function (t, e) {
        return n.__awaiter(this, void 0, void 0, function () {
          var r, i, u, a, s;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                if (!e) throw new Error("Missing key: required for decryption");
                return [4, l(t, e)];

              case 1:
                return n.sent() ? (r = o.convertHexToArrayBuffer(t.data), i = o.convertHexToArrayBuffer(t.iv), [4, d(r, e, i)]) : [2, null];

              case 2:
                u = n.sent(), a = o.convertArrayBufferToUtf8(u);

                try {
                  s = JSON.parse(a);
                } catch (t) {
                  throw t;
                }

                return [2, s];
            }
          });
        });
      };
    }, function (t, e, r) {
      window, t.exports = function (t) {
        var e = {};

        function r(n) {
          if (e[n]) return e[n].exports;
          var o = e[n] = {
            i: n,
            l: !1,
            exports: {}
          };
          return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
        }

        return r.m = t, r.c = e, r.d = function (t, e, n) {
          r.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: n
          });
        }, r.r = function (t) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(t, "__esModule", {
            value: !0
          });
        }, r.t = function (t, e) {
          if (1 & e && (t = r(t)), 8 & e) return t;
          if (4 & e && "object" == typeof t && t && t.__esModule) return t;
          var n = Object.create(null);
          if (r.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: t
          }), 2 & e && "string" != typeof t) for (var o in t) {
            r.d(n, o, function (e) {
              return t[e];
            }.bind(null, o));
          }
          return n;
        }, r.n = function (t) {
          var e = t && t.__esModule ? function () {
            return t.default;
          } : function () {
            return t;
          };
          return r.d(e, "a", e), e;
        }, r.o = function (t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }, r.p = "", r(r.s = 0);
      }([function (t, e, r) {
        "use strict";

        (function (t) {
          Object.defineProperty(e, "__esModule", {
            value: !0
          });

          var n = r(6),
              o = n.__importDefault(r(7));

          function i(t) {
            return t.toString("hex");
          }

          function u(e) {
            return new t(e, "hex");
          }

          function a(t) {
            for (var e = new Uint8Array(t), r = [], n = 0; n < e.length;) {
              var o = e[n];
              o < 128 ? (r.push(String.fromCharCode(o)), n++) : o > 191 && o < 224 ? (r.push(String.fromCharCode((31 & o) << 6 | 63 & e[n + 1])), n += 2) : (r.push(String.fromCharCode((15 & o) << 12 | (63 & e[n + 1]) << 6 | 63 & e[n + 2])), n += 3);
            }

            return r.join("");
          }

          function s(t) {
            var e = [],
                r = 0;

            for (t = encodeURI(t); r < t.length;) {
              var n = t.charCodeAt(r++);
              37 === n ? (e.push(parseInt(t.substr(r, 2), 16)), r += 2) : e.push(n);
            }

            return new Uint8Array(e).buffer;
          }

          function f(t) {
            for (var e = new Uint8Array(t), r = [], n = 0; n < e.length; n++) {
              var o = e[n];
              r.push("0123456789abcdef"[(240 & o) >> 4] + "0123456789abcdef"[15 & o]);
            }

            return r.join("");
          }

          function c(t) {
            for (var e = [], r = 0; r < t.length; r += 2) {
              e.push(parseInt(t.substr(r, 2), 16));
            }

            return new Uint8Array(e).buffer;
          }

          e.convertArrayBufferToBuffer = function (t) {
            return u(f(t));
          }, e.convertBufferToArrayBuffer = function (t) {
            return c(i(t));
          }, e.convertUtf8ToBuffer = function (e) {
            return new t(e, "utf8");
          }, e.convertBufferToUtf8 = function (t) {
            return t.toString("utf8");
          }, e.convertBufferToHex = i, e.convertHexToBuffer = u, e.concatBuffers = function () {
            for (var t = [], e = 0; e < arguments.length; e++) {
              t[e] = arguments[e];
            }

            return u(t.map(function (t) {
              return i(t);
            }).join(""));
          }, e.concatArrayBuffers = function () {
            for (var t = [], e = 0; e < arguments.length; e++) {
              t[e] = arguments[e];
            }

            return c(t.map(function (t) {
              return f(t);
            }).join(""));
          }, e.convertArrayBufferToUtf8 = a, e.convertUtf8ToArrayBuffer = s, e.convertArrayBufferToHex = f, e.convertHexToArrayBuffer = c, e.convertUtf8ToHex = function (t) {
            return f(s(t));
          }, e.convertHexToUtf8 = function (t) {
            return a(c(t));
          }, e.payloadId = function () {
            return new Date().getTime() * Math.pow(10, 3) + Math.floor(Math.random() * Math.pow(10, 3));
          }, e.uuid = function () {
            return function (t, e) {
              for (e = t = ""; t++ < 36; e += 51 * t & 52 ? (15 ^ t ? 8 ^ Math.random() * (20 ^ t ? 16 : 4) : 4).toString(16) : "-") {
                ;
              }

              return e;
            }();
          }, e.isHexStrict = function (t) {
            return ("string" == typeof t || o.default(t)) && /^(-)?0x[0-9a-f]*$/i.test(t);
          }, e.getMeta = function () {
            if ("undefined" == typeof window || "undefined" == typeof document || void 0 === window.location) return null;

            function t() {
              for (var t = [], e = 0; e < arguments.length; e++) {
                t[e] = arguments[e];
              }

              for (var r = document.getElementsByTagName("meta"), n = function n(e) {
                var n = r[e],
                    o = ["itemprop", "property", "name"].map(function (t) {
                  return n.getAttribute(t);
                }).filter(function (e) {
                  e && t.includes(e);
                });

                if (o.length && o) {
                  var i = n.getAttribute("content");
                  if (i) return {
                    value: i
                  };
                }
              }, o = 0; o < r.length; o++) {
                var i = n(o);
                if ("object" == typeof i) return i.value;
              }

              return "";
            }

            var e = function () {
              var e = t("name", "og:site_name", "og:title", "twitter:title");
              return e || (e = document.title), e;
            }();

            return {
              description: t("description", "og:description", "twitter:description", "keywords"),
              url: window.location.origin,
              icons: function () {
                for (var t = document.getElementsByTagName("link"), e = [], r = 0; r < t.length; r++) {
                  var n = t[r],
                      o = n.getAttribute("rel");

                  if (o && o.toLowerCase().indexOf("icon") > -1) {
                    var i = n.getAttribute("href");
                    if (i) if (-1 === i.toLowerCase().indexOf("https:") && -1 === i.toLowerCase().indexOf("http:") && 0 !== i.indexOf("//")) {
                      var u = window.location.protocol + "//" + window.location.host;
                      if (0 === i.indexOf("/")) u += i;else {
                        var a = window.location.pathname.split("/");
                        a.pop(), u += a.join("/") + "/" + i;
                      }
                      e.push(u);
                    } else if (0 === i.indexOf("//")) {
                      var s = window.location.protocol + i;
                      e.push(s);
                    } else e.push(i);
                  }
                }

                return e;
              }(),
              name: e
            };
          }, e.parseWalletConnectUri = function (t) {
            var e = t.indexOf(":"),
                r = -1 !== t.indexOf("?") ? t.indexOf("?") : void 0,
                o = t.substring(0, e),
                i = function (t) {
              var e = t.split("@");
              return {
                handshakeTopic: e[0],
                version: parseInt(e[1], 10)
              };
            }(t.substring(e + 1, r)),
                u = function (t) {
              for (var e = {}, r = ("?" === t[0] ? t.substr(1) : t).split("&"), n = 0; n < r.length; n++) {
                var o = r[n].match(/\w+(?==)/i) || [],
                    i = r[n].match(/=.+/i) || [];
                o[0] && (e[decodeURIComponent(o[0])] = decodeURIComponent(i[0].substr(1)));
              }

              return {
                key: e.key || "",
                bridge: e.bridge || ""
              };
            }(void 0 !== r ? t.substr(r) : "");

            return n.__assign({
              protocol: o
            }, i, u);
          }, e.promisify = function (t, e) {
            var r = this;
            return function () {
              for (var o = [], i = 0; i < arguments.length; i++) {
                o[i] = arguments[i];
              }

              return n.__awaiter(r, void 0, void 0, function () {
                return n.__generator(this, function (r) {
                  return [2, new Promise(function (r, i) {
                    t.apply(e, n.__spread(o, [function (t, e) {
                      null == t && i(t), r(e);
                    }]));
                  })];
                });
              });
            };
          }, e.formatRpcError = function (t) {
            var e = -32e3;
            if (t && !t.code) switch (t.message) {
              case "Parse error":
                e = -32700;
                break;

              case "Invalid request":
                e = -32600;
                break;

              case "Method not found":
                e = -32601;
                break;

              case "Invalid params":
                e = -32602;
                break;

              case "Internal error":
                e = -32603;
                break;

              default:
                e = -32e3;
            }
            return {
              code: e,
              message: t.message
            };
          };
        }).call(this, r(1).Buffer);
      }, function (t, e, r) {
        "use strict";

        (function (t) {
          /*!
           * The buffer module from node.js, for the browser.
           *
           * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
           * @license  MIT
           */
          var n = r(3),
              o = r(4),
              i = r(5);

          function u() {
            return s.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
          }

          function a(t, e) {
            if (u() < e) throw new RangeError("Invalid typed array length");
            return s.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = s.prototype : (null === t && (t = new s(e)), t.length = e), t;
          }

          function s(t, e, r) {
            if (!(s.TYPED_ARRAY_SUPPORT || this instanceof s)) return new s(t, e, r);

            if ("number" == typeof t) {
              if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
              return h(this, t);
            }

            return f(this, t, e, r);
          }

          function f(t, e, r, n) {
            if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
            return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
              if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
              if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
              return e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n), s.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = s.prototype : t = l(t, e), t;
            }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
              if ("string" == typeof r && "" !== r || (r = "utf8"), !s.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
              var n = 0 | d(e, r),
                  o = (t = a(t, n)).write(e, r);
              return o !== n && (t = t.slice(0, o)), t;
            }(t, e, r) : function (t, e) {
              if (s.isBuffer(e)) {
                var r = 0 | p(e.length);
                return 0 === (t = a(t, r)).length ? t : (e.copy(t, 0, 0, r), t);
              }

              if (e) {
                if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? a(t, 0) : l(t, e);
                if ("Buffer" === e.type && i(e.data)) return l(t, e.data);
              }

              var n;
              throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
            }(t, e);
          }

          function c(t) {
            if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
            if (t < 0) throw new RangeError('"size" argument must not be negative');
          }

          function h(t, e) {
            if (c(e), t = a(t, e < 0 ? 0 : 0 | p(e)), !s.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
              t[r] = 0;
            }
            return t;
          }

          function l(t, e) {
            var r = e.length < 0 ? 0 : 0 | p(e.length);
            t = a(t, r);

            for (var n = 0; n < r; n += 1) {
              t[n] = 255 & e[n];
            }

            return t;
          }

          function p(t) {
            if (t >= u()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + u().toString(16) + " bytes");
            return 0 | t;
          }

          function d(t, e) {
            if (s.isBuffer(t)) return t.length;
            if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
            "string" != typeof t && (t = "" + t);
            var r = t.length;
            if (0 === r) return 0;

            for (var n = !1;;) {
              switch (e) {
                case "ascii":
                case "latin1":
                case "binary":
                  return r;

                case "utf8":
                case "utf-8":
                case void 0:
                  return N(t).length;

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return 2 * r;

                case "hex":
                  return r >>> 1;

                case "base64":
                  return q(t).length;

                default:
                  if (n) return N(t).length;
                  e = ("" + e).toLowerCase(), n = !0;
              }
            }
          }

          function y(t, e, r) {
            var n = t[e];
            t[e] = t[r], t[r] = n;
          }

          function g(t, e, r, n, o) {
            if (0 === t.length) return -1;

            if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = o ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
              if (o) return -1;
              r = t.length - 1;
            } else if (r < 0) {
              if (!o) return -1;
              r = 0;
            }

            if ("string" == typeof e && (e = s.from(e, n)), s.isBuffer(e)) return 0 === e.length ? -1 : v(t, e, r, n, o);
            if ("number" == typeof e) return e &= 255, s.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : v(t, [e], r, n, o);
            throw new TypeError("val must be string, number or Buffer");
          }

          function v(t, e, r, n, o) {
            var i,
                u = 1,
                a = t.length,
                s = e.length;

            if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
              if (t.length < 2 || e.length < 2) return -1;
              u = 2, a /= 2, s /= 2, r /= 2;
            }

            function f(t, e) {
              return 1 === u ? t[e] : t.readUInt16BE(e * u);
            }

            if (o) {
              var c = -1;

              for (i = r; i < a; i++) {
                if (f(t, i) === f(e, -1 === c ? 0 : i - c)) {
                  if (-1 === c && (c = i), i - c + 1 === s) return c * u;
                } else -1 !== c && (i -= i - c), c = -1;
              }
            } else for (r + s > a && (r = a - s), i = r; i >= 0; i--) {
              for (var h = !0, l = 0; l < s; l++) {
                if (f(t, i + l) !== f(e, l)) {
                  h = !1;
                  break;
                }
              }

              if (h) return i;
            }

            return -1;
          }

          function _(t, e, r, n) {
            r = Number(r) || 0;
            var o = t.length - r;
            n ? (n = Number(n)) > o && (n = o) : n = o;
            var i = e.length;
            if (i % 2 != 0) throw new TypeError("Invalid hex string");
            n > i / 2 && (n = i / 2);

            for (var u = 0; u < n; ++u) {
              var a = parseInt(e.substr(2 * u, 2), 16);
              if (isNaN(a)) return u;
              t[r + u] = a;
            }

            return u;
          }

          function w(t, e, r, n) {
            return H(N(e, t.length - r), t, r, n);
          }

          function b(t, e, r, n) {
            return H(function (t) {
              for (var e = [], r = 0; r < t.length; ++r) {
                e.push(255 & t.charCodeAt(r));
              }

              return e;
            }(e), t, r, n);
          }

          function m(t, e, r, n) {
            return b(t, e, r, n);
          }

          function S(t, e, r, n) {
            return H(q(e), t, r, n);
          }

          function A(t, e, r, n) {
            return H(function (t, e) {
              for (var r, n, o, i = [], u = 0; u < t.length && !((e -= 2) < 0); ++u) {
                r = t.charCodeAt(u), n = r >> 8, o = r % 256, i.push(o), i.push(n);
              }

              return i;
            }(e, t.length - r), t, r, n);
          }

          function P(t, e, r) {
            return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
          }

          function E(t, e, r) {
            r = Math.min(t.length, r);

            for (var n = [], o = e; o < r;) {
              var i,
                  u,
                  a,
                  s,
                  f = t[o],
                  c = null,
                  h = f > 239 ? 4 : f > 223 ? 3 : f > 191 ? 2 : 1;
              if (o + h <= r) switch (h) {
                case 1:
                  f < 128 && (c = f);
                  break;

                case 2:
                  128 == (192 & (i = t[o + 1])) && (s = (31 & f) << 6 | 63 & i) > 127 && (c = s);
                  break;

                case 3:
                  i = t[o + 1], u = t[o + 2], 128 == (192 & i) && 128 == (192 & u) && (s = (15 & f) << 12 | (63 & i) << 6 | 63 & u) > 2047 && (s < 55296 || s > 57343) && (c = s);
                  break;

                case 4:
                  i = t[o + 1], u = t[o + 2], a = t[o + 3], 128 == (192 & i) && 128 == (192 & u) && 128 == (192 & a) && (s = (15 & f) << 18 | (63 & i) << 12 | (63 & u) << 6 | 63 & a) > 65535 && s < 1114112 && (c = s);
              }
              null === c ? (c = 65533, h = 1) : c > 65535 && (c -= 65536, n.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n.push(c), o += h;
            }

            return function (t) {
              var e = t.length;
              if (e <= R) return String.fromCharCode.apply(String, t);

              for (var r = "", n = 0; n < e;) {
                r += String.fromCharCode.apply(String, t.slice(n, n += R));
              }

              return r;
            }(n);
          }

          e.Buffer = s, e.SlowBuffer = function (t) {
            return +t != t && (t = 0), s.alloc(+t);
          }, e.INSPECT_MAX_BYTES = 50, s.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
            try {
              var t = new Uint8Array(1);
              return t.__proto__ = {
                __proto__: Uint8Array.prototype,
                foo: function foo() {
                  return 42;
                }
              }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
            } catch (t) {
              return !1;
            }
          }(), e.kMaxLength = u(), s.poolSize = 8192, s._augment = function (t) {
            return t.__proto__ = s.prototype, t;
          }, s.from = function (t, e, r) {
            return f(null, t, e, r);
          }, s.TYPED_ARRAY_SUPPORT && (s.prototype.__proto__ = Uint8Array.prototype, s.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && s[Symbol.species] === s && Object.defineProperty(s, Symbol.species, {
            value: null,
            configurable: !0
          })), s.alloc = function (t, e, r) {
            return function (t, e, r, n) {
              return c(e), e <= 0 ? a(t, e) : void 0 !== r ? "string" == typeof n ? a(t, e).fill(r, n) : a(t, e).fill(r) : a(t, e);
            }(null, t, e, r);
          }, s.allocUnsafe = function (t) {
            return h(null, t);
          }, s.allocUnsafeSlow = function (t) {
            return h(null, t);
          }, s.isBuffer = function (t) {
            return !(null == t || !t._isBuffer);
          }, s.compare = function (t, e) {
            if (!s.isBuffer(t) || !s.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
            if (t === e) return 0;

            for (var r = t.length, n = e.length, o = 0, i = Math.min(r, n); o < i; ++o) {
              if (t[o] !== e[o]) {
                r = t[o], n = e[o];
                break;
              }
            }

            return r < n ? -1 : n < r ? 1 : 0;
          }, s.isEncoding = function (t) {
            switch (String(t).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;

              default:
                return !1;
            }
          }, s.concat = function (t, e) {
            if (!i(t)) throw new TypeError('"list" argument must be an Array of Buffers');
            if (0 === t.length) return s.alloc(0);
            var r;
            if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
              e += t[r].length;
            }
            var n = s.allocUnsafe(e),
                o = 0;

            for (r = 0; r < t.length; ++r) {
              var u = t[r];
              if (!s.isBuffer(u)) throw new TypeError('"list" argument must be an Array of Buffers');
              u.copy(n, o), o += u.length;
            }

            return n;
          }, s.byteLength = d, s.prototype._isBuffer = !0, s.prototype.swap16 = function () {
            var t = this.length;
            if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

            for (var e = 0; e < t; e += 2) {
              y(this, e, e + 1);
            }

            return this;
          }, s.prototype.swap32 = function () {
            var t = this.length;
            if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

            for (var e = 0; e < t; e += 4) {
              y(this, e, e + 3), y(this, e + 1, e + 2);
            }

            return this;
          }, s.prototype.swap64 = function () {
            var t = this.length;
            if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

            for (var e = 0; e < t; e += 8) {
              y(this, e, e + 7), y(this, e + 1, e + 6), y(this, e + 2, e + 5), y(this, e + 3, e + 4);
            }

            return this;
          }, s.prototype.toString = function () {
            var t = 0 | this.length;
            return 0 === t ? "" : 0 === arguments.length ? E(this, 0, t) : function (t, e, r) {
              var n = !1;
              if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
              if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
              if ((r >>>= 0) <= (e >>>= 0)) return "";

              for (t || (t = "utf8");;) {
                switch (t) {
                  case "hex":
                    return I(this, e, r);

                  case "utf8":
                  case "utf-8":
                    return E(this, e, r);

                  case "ascii":
                    return O(this, e, r);

                  case "latin1":
                  case "binary":
                    return T(this, e, r);

                  case "base64":
                    return P(this, e, r);

                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return x(this, e, r);

                  default:
                    if (n) throw new TypeError("Unknown encoding: " + t);
                    t = (t + "").toLowerCase(), n = !0;
                }
              }
            }.apply(this, arguments);
          }, s.prototype.equals = function (t) {
            if (!s.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
            return this === t || 0 === s.compare(this, t);
          }, s.prototype.inspect = function () {
            var t = "",
                r = e.INSPECT_MAX_BYTES;
            return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
          }, s.prototype.compare = function (t, e, r, n, o) {
            if (!s.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
            if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === o && (o = this.length), e < 0 || r > t.length || n < 0 || o > this.length) throw new RangeError("out of range index");
            if (n >= o && e >= r) return 0;
            if (n >= o) return -1;
            if (e >= r) return 1;
            if (this === t) return 0;

            for (var i = (o >>>= 0) - (n >>>= 0), u = (r >>>= 0) - (e >>>= 0), a = Math.min(i, u), f = this.slice(n, o), c = t.slice(e, r), h = 0; h < a; ++h) {
              if (f[h] !== c[h]) {
                i = f[h], u = c[h];
                break;
              }
            }

            return i < u ? -1 : u < i ? 1 : 0;
          }, s.prototype.includes = function (t, e, r) {
            return -1 !== this.indexOf(t, e, r);
          }, s.prototype.indexOf = function (t, e, r) {
            return g(this, t, e, r, !0);
          }, s.prototype.lastIndexOf = function (t, e, r) {
            return g(this, t, e, r, !1);
          }, s.prototype.write = function (t, e, r, n) {
            if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
              if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
              e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
            }
            var o = this.length - e;
            if ((void 0 === r || r > o) && (r = o), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
            n || (n = "utf8");

            for (var i = !1;;) {
              switch (n) {
                case "hex":
                  return _(this, t, e, r);

                case "utf8":
                case "utf-8":
                  return w(this, t, e, r);

                case "ascii":
                  return b(this, t, e, r);

                case "latin1":
                case "binary":
                  return m(this, t, e, r);

                case "base64":
                  return S(this, t, e, r);

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return A(this, t, e, r);

                default:
                  if (i) throw new TypeError("Unknown encoding: " + n);
                  n = ("" + n).toLowerCase(), i = !0;
              }
            }
          }, s.prototype.toJSON = function () {
            return {
              type: "Buffer",
              data: Array.prototype.slice.call(this._arr || this, 0)
            };
          };
          var R = 4096;

          function O(t, e, r) {
            var n = "";
            r = Math.min(t.length, r);

            for (var o = e; o < r; ++o) {
              n += String.fromCharCode(127 & t[o]);
            }

            return n;
          }

          function T(t, e, r) {
            var n = "";
            r = Math.min(t.length, r);

            for (var o = e; o < r; ++o) {
              n += String.fromCharCode(t[o]);
            }

            return n;
          }

          function I(t, e, r) {
            var n = t.length;
            (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

            for (var o = "", i = e; i < r; ++i) {
              o += L(t[i]);
            }

            return o;
          }

          function x(t, e, r) {
            for (var n = t.slice(e, r), o = "", i = 0; i < n.length; i += 2) {
              o += String.fromCharCode(n[i] + 256 * n[i + 1]);
            }

            return o;
          }

          function B(t, e, r) {
            if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
            if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
          }

          function U(t, e, r, n, o, i) {
            if (!s.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (e > o || e < i) throw new RangeError('"value" argument is out of bounds');
            if (r + n > t.length) throw new RangeError("Index out of range");
          }

          function j(t, e, r, n) {
            e < 0 && (e = 65535 + e + 1);

            for (var o = 0, i = Math.min(t.length - r, 2); o < i; ++o) {
              t[r + o] = (e & 255 << 8 * (n ? o : 1 - o)) >>> 8 * (n ? o : 1 - o);
            }
          }

          function M(t, e, r, n) {
            e < 0 && (e = 4294967295 + e + 1);

            for (var o = 0, i = Math.min(t.length - r, 4); o < i; ++o) {
              t[r + o] = e >>> 8 * (n ? o : 3 - o) & 255;
            }
          }

          function k(t, e, r, n, o, i) {
            if (r + n > t.length) throw new RangeError("Index out of range");
            if (r < 0) throw new RangeError("Index out of range");
          }

          function C(t, e, r, n, i) {
            return i || k(t, 0, r, 4), o.write(t, e, r, n, 23, 4), r + 4;
          }

          function Y(t, e, r, n, i) {
            return i || k(t, 0, r, 8), o.write(t, e, r, n, 52, 8), r + 8;
          }

          s.prototype.slice = function (t, e) {
            var r,
                n = this.length;
            if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), s.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = s.prototype;else {
              var o = e - t;
              r = new s(o, void 0);

              for (var i = 0; i < o; ++i) {
                r[i] = this[i + t];
              }
            }
            return r;
          }, s.prototype.readUIntLE = function (t, e, r) {
            t |= 0, e |= 0, r || B(t, e, this.length);

            for (var n = this[t], o = 1, i = 0; ++i < e && (o *= 256);) {
              n += this[t + i] * o;
            }

            return n;
          }, s.prototype.readUIntBE = function (t, e, r) {
            t |= 0, e |= 0, r || B(t, e, this.length);

            for (var n = this[t + --e], o = 1; e > 0 && (o *= 256);) {
              n += this[t + --e] * o;
            }

            return n;
          }, s.prototype.readUInt8 = function (t, e) {
            return e || B(t, 1, this.length), this[t];
          }, s.prototype.readUInt16LE = function (t, e) {
            return e || B(t, 2, this.length), this[t] | this[t + 1] << 8;
          }, s.prototype.readUInt16BE = function (t, e) {
            return e || B(t, 2, this.length), this[t] << 8 | this[t + 1];
          }, s.prototype.readUInt32LE = function (t, e) {
            return e || B(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
          }, s.prototype.readUInt32BE = function (t, e) {
            return e || B(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
          }, s.prototype.readIntLE = function (t, e, r) {
            t |= 0, e |= 0, r || B(t, e, this.length);

            for (var n = this[t], o = 1, i = 0; ++i < e && (o *= 256);) {
              n += this[t + i] * o;
            }

            return n >= (o *= 128) && (n -= Math.pow(2, 8 * e)), n;
          }, s.prototype.readIntBE = function (t, e, r) {
            t |= 0, e |= 0, r || B(t, e, this.length);

            for (var n = e, o = 1, i = this[t + --n]; n > 0 && (o *= 256);) {
              i += this[t + --n] * o;
            }

            return i >= (o *= 128) && (i -= Math.pow(2, 8 * e)), i;
          }, s.prototype.readInt8 = function (t, e) {
            return e || B(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
          }, s.prototype.readInt16LE = function (t, e) {
            e || B(t, 2, this.length);
            var r = this[t] | this[t + 1] << 8;
            return 32768 & r ? 4294901760 | r : r;
          }, s.prototype.readInt16BE = function (t, e) {
            e || B(t, 2, this.length);
            var r = this[t + 1] | this[t] << 8;
            return 32768 & r ? 4294901760 | r : r;
          }, s.prototype.readInt32LE = function (t, e) {
            return e || B(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
          }, s.prototype.readInt32BE = function (t, e) {
            return e || B(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
          }, s.prototype.readFloatLE = function (t, e) {
            return e || B(t, 4, this.length), o.read(this, t, !0, 23, 4);
          }, s.prototype.readFloatBE = function (t, e) {
            return e || B(t, 4, this.length), o.read(this, t, !1, 23, 4);
          }, s.prototype.readDoubleLE = function (t, e) {
            return e || B(t, 8, this.length), o.read(this, t, !0, 52, 8);
          }, s.prototype.readDoubleBE = function (t, e) {
            return e || B(t, 8, this.length), o.read(this, t, !1, 52, 8);
          }, s.prototype.writeUIntLE = function (t, e, r, n) {
            t = +t, e |= 0, r |= 0, n || U(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
            var o = 1,
                i = 0;

            for (this[e] = 255 & t; ++i < r && (o *= 256);) {
              this[e + i] = t / o & 255;
            }

            return e + r;
          }, s.prototype.writeUIntBE = function (t, e, r, n) {
            t = +t, e |= 0, r |= 0, n || U(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
            var o = r - 1,
                i = 1;

            for (this[e + o] = 255 & t; --o >= 0 && (i *= 256);) {
              this[e + o] = t / i & 255;
            }

            return e + r;
          }, s.prototype.writeUInt8 = function (t, e, r) {
            return t = +t, e |= 0, r || U(this, t, e, 1, 255, 0), s.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
          }, s.prototype.writeUInt16LE = function (t, e, r) {
            return t = +t, e |= 0, r || U(this, t, e, 2, 65535, 0), s.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : j(this, t, e, !0), e + 2;
          }, s.prototype.writeUInt16BE = function (t, e, r) {
            return t = +t, e |= 0, r || U(this, t, e, 2, 65535, 0), s.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : j(this, t, e, !1), e + 2;
          }, s.prototype.writeUInt32LE = function (t, e, r) {
            return t = +t, e |= 0, r || U(this, t, e, 4, 4294967295, 0), s.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : M(this, t, e, !0), e + 4;
          }, s.prototype.writeUInt32BE = function (t, e, r) {
            return t = +t, e |= 0, r || U(this, t, e, 4, 4294967295, 0), s.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : M(this, t, e, !1), e + 4;
          }, s.prototype.writeIntLE = function (t, e, r, n) {
            if (t = +t, e |= 0, !n) {
              var o = Math.pow(2, 8 * r - 1);
              U(this, t, e, r, o - 1, -o);
            }

            var i = 0,
                u = 1,
                a = 0;

            for (this[e] = 255 & t; ++i < r && (u *= 256);) {
              t < 0 && 0 === a && 0 !== this[e + i - 1] && (a = 1), this[e + i] = (t / u >> 0) - a & 255;
            }

            return e + r;
          }, s.prototype.writeIntBE = function (t, e, r, n) {
            if (t = +t, e |= 0, !n) {
              var o = Math.pow(2, 8 * r - 1);
              U(this, t, e, r, o - 1, -o);
            }

            var i = r - 1,
                u = 1,
                a = 0;

            for (this[e + i] = 255 & t; --i >= 0 && (u *= 256);) {
              t < 0 && 0 === a && 0 !== this[e + i + 1] && (a = 1), this[e + i] = (t / u >> 0) - a & 255;
            }

            return e + r;
          }, s.prototype.writeInt8 = function (t, e, r) {
            return t = +t, e |= 0, r || U(this, t, e, 1, 127, -128), s.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
          }, s.prototype.writeInt16LE = function (t, e, r) {
            return t = +t, e |= 0, r || U(this, t, e, 2, 32767, -32768), s.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : j(this, t, e, !0), e + 2;
          }, s.prototype.writeInt16BE = function (t, e, r) {
            return t = +t, e |= 0, r || U(this, t, e, 2, 32767, -32768), s.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : j(this, t, e, !1), e + 2;
          }, s.prototype.writeInt32LE = function (t, e, r) {
            return t = +t, e |= 0, r || U(this, t, e, 4, 2147483647, -2147483648), s.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : M(this, t, e, !0), e + 4;
          }, s.prototype.writeInt32BE = function (t, e, r) {
            return t = +t, e |= 0, r || U(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), s.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : M(this, t, e, !1), e + 4;
          }, s.prototype.writeFloatLE = function (t, e, r) {
            return C(this, t, e, !0, r);
          }, s.prototype.writeFloatBE = function (t, e, r) {
            return C(this, t, e, !1, r);
          }, s.prototype.writeDoubleLE = function (t, e, r) {
            return Y(this, t, e, !0, r);
          }, s.prototype.writeDoubleBE = function (t, e, r) {
            return Y(this, t, e, !1, r);
          }, s.prototype.copy = function (t, e, r, n) {
            if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
            if (0 === t.length || 0 === this.length) return 0;
            if (e < 0) throw new RangeError("targetStart out of bounds");
            if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
            if (n < 0) throw new RangeError("sourceEnd out of bounds");
            n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
            var o,
                i = n - r;
            if (this === t && r < e && e < n) for (o = i - 1; o >= 0; --o) {
              t[o + e] = this[o + r];
            } else if (i < 1e3 || !s.TYPED_ARRAY_SUPPORT) for (o = 0; o < i; ++o) {
              t[o + e] = this[o + r];
            } else Uint8Array.prototype.set.call(t, this.subarray(r, r + i), e);
            return i;
          }, s.prototype.fill = function (t, e, r, n) {
            if ("string" == typeof t) {
              if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
                var o = t.charCodeAt(0);
                o < 256 && (t = o);
              }

              if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
              if ("string" == typeof n && !s.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
            } else "number" == typeof t && (t &= 255);

            if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
            if (r <= e) return this;
            var i;
            if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (i = e; i < r; ++i) {
              this[i] = t;
            } else {
              var u = s.isBuffer(t) ? t : N(new s(t, n).toString()),
                  a = u.length;

              for (i = 0; i < r - e; ++i) {
                this[i + e] = u[i % a];
              }
            }
            return this;
          };
          var D = /[^+\/0-9A-Za-z-_]/g;

          function L(t) {
            return t < 16 ? "0" + t.toString(16) : t.toString(16);
          }

          function N(t, e) {
            var r;
            e = e || 1 / 0;

            for (var n = t.length, o = null, i = [], u = 0; u < n; ++u) {
              if ((r = t.charCodeAt(u)) > 55295 && r < 57344) {
                if (!o) {
                  if (r > 56319) {
                    (e -= 3) > -1 && i.push(239, 191, 189);
                    continue;
                  }

                  if (u + 1 === n) {
                    (e -= 3) > -1 && i.push(239, 191, 189);
                    continue;
                  }

                  o = r;
                  continue;
                }

                if (r < 56320) {
                  (e -= 3) > -1 && i.push(239, 191, 189), o = r;
                  continue;
                }

                r = 65536 + (o - 55296 << 10 | r - 56320);
              } else o && (e -= 3) > -1 && i.push(239, 191, 189);

              if (o = null, r < 128) {
                if ((e -= 1) < 0) break;
                i.push(r);
              } else if (r < 2048) {
                if ((e -= 2) < 0) break;
                i.push(r >> 6 | 192, 63 & r | 128);
              } else if (r < 65536) {
                if ((e -= 3) < 0) break;
                i.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
              } else {
                if (!(r < 1114112)) throw new Error("Invalid code point");
                if ((e -= 4) < 0) break;
                i.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
              }
            }

            return i;
          }

          function q(t) {
            return n.toByteArray(function (t) {
              if ((t = function (t) {
                return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
              }(t).replace(D, "")).length < 2) return "";

              for (; t.length % 4 != 0;) {
                t += "=";
              }

              return t;
            }(t));
          }

          function H(t, e, r, n) {
            for (var o = 0; o < n && !(o + r >= e.length || o >= t.length); ++o) {
              e[o + r] = t[o];
            }

            return o;
          }
        }).call(this, r(2));
      }, function (t, e) {
        var r;

        r = function () {
          return this;
        }();

        try {
          r = r || new Function("return this")();
        } catch (t) {
          "object" == typeof window && (r = window);
        }

        t.exports = r;
      }, function (t, e, r) {
        "use strict";

        e.byteLength = function (t) {
          var e = f(t),
              r = e[0],
              n = e[1];
          return 3 * (r + n) / 4 - n;
        }, e.toByteArray = function (t) {
          for (var e, r = f(t), n = r[0], u = r[1], a = new i(NaN), s = 0, c = u > 0 ? n - 4 : n, h = 0; h < c; h += 4) {
            e = o[t.charCodeAt(h)] << 18 | o[t.charCodeAt(h + 1)] << 12 | o[t.charCodeAt(h + 2)] << 6 | o[t.charCodeAt(h + 3)], a[s++] = e >> 16 & 255, a[s++] = e >> 8 & 255, a[s++] = 255 & e;
          }

          return 2 === u && (e = o[t.charCodeAt(h)] << 2 | o[t.charCodeAt(h + 1)] >> 4, a[s++] = 255 & e), 1 === u && (e = o[t.charCodeAt(h)] << 10 | o[t.charCodeAt(h + 1)] << 4 | o[t.charCodeAt(h + 2)] >> 2, a[s++] = e >> 8 & 255, a[s++] = 255 & e), a;
        }, e.fromByteArray = function (t) {
          for (var e, r = t.length, o = r % 3, i = [], u = 0, a = r - o; u < a; u += 16383) {
            i.push(c(t, u, u + 16383 > a ? a : u + 16383));
          }

          return 1 === o ? (e = t[r - 1], i.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === o && (e = (t[r - 2] << 8) + t[r - 1], i.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "=")), i.join("");
        };

        for (var n = [], o = [], i = "undefined" != typeof Uint8Array ? Uint8Array : Array, u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, s = u.length; a < s; ++a) {
          n[a] = u[a], o[u.charCodeAt(a)] = a;
        }

        function f(t) {
          var e = t.length;
          if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
          var r = t.indexOf("=");
          return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
        }

        function c(t, e, r) {
          for (var o, i, u = [], a = e; a < r; a += 3) {
            o = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (255 & t[a + 2]), u.push(n[(i = o) >> 18 & 63] + n[i >> 12 & 63] + n[i >> 6 & 63] + n[63 & i]);
          }

          return u.join("");
        }

        o["-".charCodeAt(0)] = 62, o["_".charCodeAt(0)] = 63;
      }, function (t, e) {
        e.read = function (t, e, r, n, o) {
          var i,
              u,
              a = 8 * o - n - 1,
              s = (1 << a) - 1,
              f = s >> 1,
              c = -7,
              h = r ? o - 1 : 0,
              l = r ? -1 : 1,
              p = t[e + h];

          for (h += l, i = p & (1 << -c) - 1, p >>= -c, c += a; c > 0; i = 256 * i + t[e + h], h += l, c -= 8) {
            ;
          }

          for (u = i & (1 << -c) - 1, i >>= -c, c += n; c > 0; u = 256 * u + t[e + h], h += l, c -= 8) {
            ;
          }

          if (0 === i) i = 1 - f;else {
            if (i === s) return u ? NaN : 1 / 0 * (p ? -1 : 1);
            u += Math.pow(2, n), i -= f;
          }
          return (p ? -1 : 1) * u * Math.pow(2, i - n);
        }, e.write = function (t, e, r, n, o, i) {
          var u,
              a,
              s,
              f = 8 * i - o - 1,
              c = (1 << f) - 1,
              h = c >> 1,
              l = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
              p = n ? 0 : i - 1,
              d = n ? 1 : -1,
              y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

          for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, u = c) : (u = Math.floor(Math.log(e) / Math.LN2), e * (s = Math.pow(2, -u)) < 1 && (u--, s *= 2), (e += u + h >= 1 ? l / s : l * Math.pow(2, 1 - h)) * s >= 2 && (u++, s /= 2), u + h >= c ? (a = 0, u = c) : u + h >= 1 ? (a = (e * s - 1) * Math.pow(2, o), u += h) : (a = e * Math.pow(2, h - 1) * Math.pow(2, o), u = 0)); o >= 8; t[r + p] = 255 & a, p += d, a /= 256, o -= 8) {
            ;
          }

          for (u = u << o | a, f += o; f > 0; t[r + p] = 255 & u, p += d, u /= 256, f -= 8) {
            ;
          }

          t[r + p - d] |= 128 * y;
        };
      }, function (t, e) {
        var r = {}.toString;

        t.exports = Array.isArray || function (t) {
          return "[object Array]" == r.call(t);
        };
      }, function (t, e, r) {
        "use strict";

        r.r(e), r.d(e, "__extends", function () {
          return o;
        }), r.d(e, "__assign", function () {
          return _i5;
        }), r.d(e, "__rest", function () {
          return u;
        }), r.d(e, "__decorate", function () {
          return a;
        }), r.d(e, "__param", function () {
          return s;
        }), r.d(e, "__metadata", function () {
          return f;
        }), r.d(e, "__awaiter", function () {
          return c;
        }), r.d(e, "__generator", function () {
          return h;
        }), r.d(e, "__exportStar", function () {
          return l;
        }), r.d(e, "__values", function () {
          return p;
        }), r.d(e, "__read", function () {
          return d;
        }), r.d(e, "__spread", function () {
          return y;
        }), r.d(e, "__await", function () {
          return g;
        }), r.d(e, "__asyncGenerator", function () {
          return v;
        }), r.d(e, "__asyncDelegator", function () {
          return _;
        }), r.d(e, "__asyncValues", function () {
          return w;
        }), r.d(e, "__makeTemplateObject", function () {
          return b;
        }), r.d(e, "__importStar", function () {
          return m;
        }), r.d(e, "__importDefault", function () {
          return S;
        });
        /*! *****************************************************************************
        Copyright (c) Microsoft Corporation. All rights reserved.
        Licensed under the Apache License, Version 2.0 (the "License"); you may not use
        this file except in compliance with the License. You may obtain a copy of the
        License at http://www.apache.org/licenses/LICENSE-2.0
        
        THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
        WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
        MERCHANTABLITY OR NON-INFRINGEMENT.
        
        See the Apache Version 2.0 License for specific language governing permissions
        and limitations under the License.
        ***************************************************************************** */

        var _n5 = function n(t, e) {
          return (_n5 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (t, e) {
            t.__proto__ = e;
          } || function (t, e) {
            for (var r in e) {
              e.hasOwnProperty(r) && (t[r] = e[r]);
            }
          })(t, e);
        };

        function o(t, e) {
          function r() {
            this.constructor = t;
          }

          _n5(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
        }

        var _i5 = function i() {
          return (_i5 = Object.assign || function (t) {
            for (var e, r = 1, n = arguments.length; r < n; r++) {
              for (var o in e = arguments[r]) {
                Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              }
            }

            return t;
          }).apply(this, arguments);
        };

        function u(t, e) {
          var r = {};

          for (var n in t) {
            Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
          }

          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;

            for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) {
              e.indexOf(n[o]) < 0 && (r[n[o]] = t[n[o]]);
            }
          }

          return r;
        }

        function a(t, e, r, n) {
          var o,
              i = arguments.length,
              u = i < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
          if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) u = Reflect.decorate(t, e, r, n);else for (var a = t.length - 1; a >= 0; a--) {
            (o = t[a]) && (u = (i < 3 ? o(u) : i > 3 ? o(e, r, u) : o(e, r)) || u);
          }
          return i > 3 && u && Object.defineProperty(e, r, u), u;
        }

        function s(t, e) {
          return function (r, n) {
            e(r, n, t);
          };
        }

        function f(t, e) {
          if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
        }

        function c(t, e, r, n) {
          return new (r || (r = Promise))(function (o, i) {
            function u(t) {
              try {
                s(n.next(t));
              } catch (t) {
                i(t);
              }
            }

            function a(t) {
              try {
                s(n.throw(t));
              } catch (t) {
                i(t);
              }
            }

            function s(t) {
              t.done ? o(t.value) : new r(function (e) {
                e(t.value);
              }).then(u, a);
            }

            s((n = n.apply(t, e || [])).next());
          });
        }

        function h(t, e) {
          var r,
              n,
              o,
              i,
              u = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
          return i = {
            next: a(0),
            throw: a(1),
            return: a(2)
          }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
            return this;
          }), i;

          function a(i) {
            return function (a) {
              return function (i) {
                if (r) throw new TypeError("Generator is already executing.");

                for (; u;) {
                  try {
                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                    switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                      case 0:
                      case 1:
                        o = i;
                        break;

                      case 4:
                        return u.label++, {
                          value: i[1],
                          done: !1
                        };

                      case 5:
                        u.label++, n = i[1], i = [0];
                        continue;

                      case 7:
                        i = u.ops.pop(), u.trys.pop();
                        continue;

                      default:
                        if (!(o = (o = u.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                          u = 0;
                          continue;
                        }

                        if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                          u.label = i[1];
                          break;
                        }

                        if (6 === i[0] && u.label < o[1]) {
                          u.label = o[1], o = i;
                          break;
                        }

                        if (o && u.label < o[2]) {
                          u.label = o[2], u.ops.push(i);
                          break;
                        }

                        o[2] && u.ops.pop(), u.trys.pop();
                        continue;
                    }

                    i = e.call(t, u);
                  } catch (t) {
                    i = [6, t], n = 0;
                  } finally {
                    r = o = 0;
                  }
                }

                if (5 & i[0]) throw i[1];
                return {
                  value: i[0] ? i[1] : void 0,
                  done: !0
                };
              }([i, a]);
            };
          }
        }

        function l(t, e) {
          for (var r in t) {
            e.hasOwnProperty(r) || (e[r] = t[r]);
          }
        }

        function p(t) {
          var e = "function" == typeof Symbol && t[Symbol.iterator],
              r = 0;
          return e ? e.call(t) : {
            next: function next() {
              return t && r >= t.length && (t = void 0), {
                value: t && t[r++],
                done: !t
              };
            }
          };
        }

        function d(t, e) {
          var r = "function" == typeof Symbol && t[Symbol.iterator];
          if (!r) return t;
          var n,
              o,
              i = r.call(t),
              u = [];

          try {
            for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) {
              u.push(n.value);
            }
          } catch (t) {
            o = {
              error: t
            };
          } finally {
            try {
              n && !n.done && (r = i.return) && r.call(i);
            } finally {
              if (o) throw o.error;
            }
          }

          return u;
        }

        function y() {
          for (var t = [], e = 0; e < arguments.length; e++) {
            t = t.concat(d(arguments[e]));
          }

          return t;
        }

        function g(t) {
          return this instanceof g ? (this.v = t, this) : new g(t);
        }

        function v(t, e, r) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var n,
              o = r.apply(t, e || []),
              i = [];
          return n = {}, u("next"), u("throw"), u("return"), n[Symbol.asyncIterator] = function () {
            return this;
          }, n;

          function u(t) {
            o[t] && (n[t] = function (e) {
              return new Promise(function (r, n) {
                i.push([t, e, r, n]) > 1 || a(t, e);
              });
            });
          }

          function a(t, e) {
            try {
              (r = o[t](e)).value instanceof g ? Promise.resolve(r.value.v).then(s, f) : c(i[0][2], r);
            } catch (t) {
              c(i[0][3], t);
            }

            var r;
          }

          function s(t) {
            a("next", t);
          }

          function f(t) {
            a("throw", t);
          }

          function c(t, e) {
            t(e), i.shift(), i.length && a(i[0][0], i[0][1]);
          }
        }

        function _(t) {
          var e, r;
          return e = {}, n("next"), n("throw", function (t) {
            throw t;
          }), n("return"), e[Symbol.iterator] = function () {
            return this;
          }, e;

          function n(n, o) {
            e[n] = t[n] ? function (e) {
              return (r = !r) ? {
                value: g(t[n](e)),
                done: "return" === n
              } : o ? o(e) : e;
            } : o;
          }
        }

        function w(t) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var e,
              r = t[Symbol.asyncIterator];
          return r ? r.call(t) : (t = p(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
            return this;
          }, e);

          function n(r) {
            e[r] = t[r] && function (e) {
              return new Promise(function (n, o) {
                !function (t, e, r, n) {
                  Promise.resolve(n).then(function (e) {
                    t({
                      value: e,
                      done: r
                    });
                  }, e);
                }(n, o, (e = t[r](e)).done, e.value);
              });
            };
          }
        }

        function b(t, e) {
          return Object.defineProperty ? Object.defineProperty(t, "raw", {
            value: e
          }) : t.raw = e, t;
        }

        function m(t) {
          if (t && t.__esModule) return t;
          var e = {};
          if (null != t) for (var r in t) {
            Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
          return e.default = t, e;
        }

        function S(t) {
          return t && t.__esModule ? t : {
            default: t
          };
        }
      }, function (t, e) {
        var r = Object.prototype.toString;

        t.exports = function (t) {
          return "number" == typeof t || function (t) {
            return !!t && "object" == typeof t;
          }(t) && "[object Number]" == r.call(t);
        };
      }]);
    }]);
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var n = r(0),
        o = r(4),
        i = function () {
      function t() {}

      return t._createFinalPayload = function (e) {
        return n.__assign({
          id: t._getRandomId(),
          jsonrpc: "2.0",
          params: []
        }, e);
      }, t._getRandomId = function () {
        return o.payloadId();
      }, t.prototype.emitPayloadAsync = function (e) {
        return n.__awaiter(this, void 0, void 0, function () {
          var r;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return r = t._createFinalPayload(e), [4, o.promisify(this.engine.sendAsync, this.engine)(r)];

              case 1:
                return [2, n.sent()];
            }
          });
        });
      }, t.prototype.setEngine = function (t) {
        this.engine = t;
      }, t;
    }();

    e.default = i;
  }, function (t, e, r) {
    window, t.exports = function (t) {
      var e = {};

      function r(n) {
        if (e[n]) return e[n].exports;
        var o = e[n] = {
          i: n,
          l: !1,
          exports: {}
        };
        return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
      }

      return r.m = t, r.c = e, r.d = function (t, e, n) {
        r.o(t, e) || Object.defineProperty(t, e, {
          enumerable: !0,
          get: n
        });
      }, r.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }, r.t = function (t, e) {
        if (1 & e && (t = r(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
          enumerable: !0,
          value: t
        }), 2 & e && "string" != typeof t) for (var o in t) {
          r.d(n, o, function (e) {
            return t[e];
          }.bind(null, o));
        }
        return n;
      }, r.n = function (t) {
        var e = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return r.d(e, "a", e), e;
      }, r.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, r.p = "", r(r.s = 0);
    }([function (t, e, r) {
      "use strict";

      (function (t) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });

        var n = r(6),
            o = n.__importDefault(r(7));

        function i(t) {
          return t.toString("hex");
        }

        function u(e) {
          return new t(e, "hex");
        }

        function a(t) {
          for (var e = new Uint8Array(t), r = [], n = 0; n < e.length;) {
            var o = e[n];
            o < 128 ? (r.push(String.fromCharCode(o)), n++) : o > 191 && o < 224 ? (r.push(String.fromCharCode((31 & o) << 6 | 63 & e[n + 1])), n += 2) : (r.push(String.fromCharCode((15 & o) << 12 | (63 & e[n + 1]) << 6 | 63 & e[n + 2])), n += 3);
          }

          return r.join("");
        }

        function s(t) {
          var e = [],
              r = 0;

          for (t = encodeURI(t); r < t.length;) {
            var n = t.charCodeAt(r++);
            37 === n ? (e.push(parseInt(t.substr(r, 2), 16)), r += 2) : e.push(n);
          }

          return new Uint8Array(e).buffer;
        }

        function f(t) {
          for (var e = new Uint8Array(t), r = [], n = 0; n < e.length; n++) {
            var o = e[n];
            r.push("0123456789abcdef"[(240 & o) >> 4] + "0123456789abcdef"[15 & o]);
          }

          return r.join("");
        }

        function c(t) {
          for (var e = [], r = 0; r < t.length; r += 2) {
            e.push(parseInt(t.substr(r, 2), 16));
          }

          return new Uint8Array(e).buffer;
        }

        e.convertArrayBufferToBuffer = function (t) {
          return u(f(t));
        }, e.convertBufferToArrayBuffer = function (t) {
          return c(i(t));
        }, e.convertUtf8ToBuffer = function (e) {
          return new t(e, "utf8");
        }, e.convertBufferToUtf8 = function (t) {
          return t.toString("utf8");
        }, e.convertBufferToHex = i, e.convertHexToBuffer = u, e.concatBuffers = function () {
          for (var t = [], e = 0; e < arguments.length; e++) {
            t[e] = arguments[e];
          }

          return u(t.map(function (t) {
            return i(t);
          }).join(""));
        }, e.concatArrayBuffers = function () {
          for (var t = [], e = 0; e < arguments.length; e++) {
            t[e] = arguments[e];
          }

          return c(t.map(function (t) {
            return f(t);
          }).join(""));
        }, e.convertArrayBufferToUtf8 = a, e.convertUtf8ToArrayBuffer = s, e.convertArrayBufferToHex = f, e.convertHexToArrayBuffer = c, e.convertUtf8ToHex = function (t) {
          return f(s(t));
        }, e.convertHexToUtf8 = function (t) {
          return a(c(t));
        }, e.payloadId = function () {
          return new Date().getTime() * Math.pow(10, 3) + Math.floor(Math.random() * Math.pow(10, 3));
        }, e.uuid = function () {
          return function (t, e) {
            for (e = t = ""; t++ < 36; e += 51 * t & 52 ? (15 ^ t ? 8 ^ Math.random() * (20 ^ t ? 16 : 4) : 4).toString(16) : "-") {
              ;
            }

            return e;
          }();
        }, e.isHexStrict = function (t) {
          return ("string" == typeof t || o.default(t)) && /^(-)?0x[0-9a-f]*$/i.test(t);
        }, e.getMeta = function () {
          if ("undefined" == typeof window || "undefined" == typeof document || void 0 === window.location) return null;

          function t() {
            for (var t = [], e = 0; e < arguments.length; e++) {
              t[e] = arguments[e];
            }

            for (var r = document.getElementsByTagName("meta"), n = function n(e) {
              var n = r[e],
                  o = ["itemprop", "property", "name"].map(function (t) {
                return n.getAttribute(t);
              }).filter(function (e) {
                e && t.includes(e);
              });

              if (o.length && o) {
                var i = n.getAttribute("content");
                if (i) return {
                  value: i
                };
              }
            }, o = 0; o < r.length; o++) {
              var i = n(o);
              if ("object" == typeof i) return i.value;
            }

            return "";
          }

          var e = function () {
            var e = t("name", "og:site_name", "og:title", "twitter:title");
            return e || (e = document.title), e;
          }();

          return {
            description: t("description", "og:description", "twitter:description", "keywords"),
            url: window.location.origin,
            icons: function () {
              for (var t = document.getElementsByTagName("link"), e = [], r = 0; r < t.length; r++) {
                var n = t[r],
                    o = n.getAttribute("rel");

                if (o && o.toLowerCase().indexOf("icon") > -1) {
                  var i = n.getAttribute("href");
                  if (i) if (-1 === i.toLowerCase().indexOf("https:") && -1 === i.toLowerCase().indexOf("http:") && 0 !== i.indexOf("//")) {
                    var u = window.location.protocol + "//" + window.location.host;
                    if (0 === i.indexOf("/")) u += i;else {
                      var a = window.location.pathname.split("/");
                      a.pop(), u += a.join("/") + "/" + i;
                    }
                    e.push(u);
                  } else if (0 === i.indexOf("//")) {
                    var s = window.location.protocol + i;
                    e.push(s);
                  } else e.push(i);
                }
              }

              return e;
            }(),
            name: e
          };
        }, e.parseWalletConnectUri = function (t) {
          var e = t.indexOf(":"),
              r = -1 !== t.indexOf("?") ? t.indexOf("?") : void 0,
              o = t.substring(0, e),
              i = function (t) {
            var e = t.split("@");
            return {
              handshakeTopic: e[0],
              version: parseInt(e[1], 10)
            };
          }(t.substring(e + 1, r)),
              u = function (t) {
            for (var e = {}, r = ("?" === t[0] ? t.substr(1) : t).split("&"), n = 0; n < r.length; n++) {
              var o = r[n].match(/\w+(?==)/i) || [],
                  i = r[n].match(/=.+/i) || [];
              o[0] && (e[decodeURIComponent(o[0])] = decodeURIComponent(i[0].substr(1)));
            }

            return {
              key: e.key || "",
              bridge: e.bridge || ""
            };
          }(void 0 !== r ? t.substr(r) : "");

          return n.__assign({
            protocol: o
          }, i, u);
        }, e.promisify = function (t, e) {
          var r = this;
          return function () {
            for (var o = [], i = 0; i < arguments.length; i++) {
              o[i] = arguments[i];
            }

            return n.__awaiter(r, void 0, void 0, function () {
              return n.__generator(this, function (r) {
                return [2, new Promise(function (r, i) {
                  t.apply(e, n.__spread(o, [function (t, e) {
                    null == t && i(t), r(e);
                  }]));
                })];
              });
            });
          };
        }, e.formatRpcError = function (t) {
          var e = -32e3;
          if (t && !t.code) switch (t.message) {
            case "Parse error":
              e = -32700;
              break;

            case "Invalid request":
              e = -32600;
              break;

            case "Method not found":
              e = -32601;
              break;

            case "Invalid params":
              e = -32602;
              break;

            case "Internal error":
              e = -32603;
              break;

            default:
              e = -32e3;
          }
          return {
            code: e,
            message: t.message
          };
        };
      }).call(this, r(1).Buffer);
    }, function (t, e, r) {
      "use strict";

      (function (t) {
        /*!
         * The buffer module from node.js, for the browser.
         *
         * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
         * @license  MIT
         */
        var n = r(3),
            o = r(4),
            i = r(5);

        function u() {
          return s.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
        }

        function a(t, e) {
          if (u() < e) throw new RangeError("Invalid typed array length");
          return s.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = s.prototype : (null === t && (t = new s(e)), t.length = e), t;
        }

        function s(t, e, r) {
          if (!(s.TYPED_ARRAY_SUPPORT || this instanceof s)) return new s(t, e, r);

          if ("number" == typeof t) {
            if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
            return h(this, t);
          }

          return f(this, t, e, r);
        }

        function f(t, e, r, n) {
          if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
          return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
            if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
            if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
            return e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n), s.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = s.prototype : t = l(t, e), t;
          }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
            if ("string" == typeof r && "" !== r || (r = "utf8"), !s.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
            var n = 0 | d(e, r),
                o = (t = a(t, n)).write(e, r);
            return o !== n && (t = t.slice(0, o)), t;
          }(t, e, r) : function (t, e) {
            if (s.isBuffer(e)) {
              var r = 0 | p(e.length);
              return 0 === (t = a(t, r)).length ? t : (e.copy(t, 0, 0, r), t);
            }

            if (e) {
              if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? a(t, 0) : l(t, e);
              if ("Buffer" === e.type && i(e.data)) return l(t, e.data);
            }

            var n;
            throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
          }(t, e);
        }

        function c(t) {
          if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
          if (t < 0) throw new RangeError('"size" argument must not be negative');
        }

        function h(t, e) {
          if (c(e), t = a(t, e < 0 ? 0 : 0 | p(e)), !s.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
            t[r] = 0;
          }
          return t;
        }

        function l(t, e) {
          var r = e.length < 0 ? 0 : 0 | p(e.length);
          t = a(t, r);

          for (var n = 0; n < r; n += 1) {
            t[n] = 255 & e[n];
          }

          return t;
        }

        function p(t) {
          if (t >= u()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + u().toString(16) + " bytes");
          return 0 | t;
        }

        function d(t, e) {
          if (s.isBuffer(t)) return t.length;
          if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
          "string" != typeof t && (t = "" + t);
          var r = t.length;
          if (0 === r) return 0;

          for (var n = !1;;) {
            switch (e) {
              case "ascii":
              case "latin1":
              case "binary":
                return r;

              case "utf8":
              case "utf-8":
              case void 0:
                return N(t).length;

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return 2 * r;

              case "hex":
                return r >>> 1;

              case "base64":
                return q(t).length;

              default:
                if (n) return N(t).length;
                e = ("" + e).toLowerCase(), n = !0;
            }
          }
        }

        function y(t, e, r) {
          var n = t[e];
          t[e] = t[r], t[r] = n;
        }

        function g(t, e, r, n, o) {
          if (0 === t.length) return -1;

          if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = o ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
            if (o) return -1;
            r = t.length - 1;
          } else if (r < 0) {
            if (!o) return -1;
            r = 0;
          }

          if ("string" == typeof e && (e = s.from(e, n)), s.isBuffer(e)) return 0 === e.length ? -1 : v(t, e, r, n, o);
          if ("number" == typeof e) return e &= 255, s.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : v(t, [e], r, n, o);
          throw new TypeError("val must be string, number or Buffer");
        }

        function v(t, e, r, n, o) {
          var i,
              u = 1,
              a = t.length,
              s = e.length;

          if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
            if (t.length < 2 || e.length < 2) return -1;
            u = 2, a /= 2, s /= 2, r /= 2;
          }

          function f(t, e) {
            return 1 === u ? t[e] : t.readUInt16BE(e * u);
          }

          if (o) {
            var c = -1;

            for (i = r; i < a; i++) {
              if (f(t, i) === f(e, -1 === c ? 0 : i - c)) {
                if (-1 === c && (c = i), i - c + 1 === s) return c * u;
              } else -1 !== c && (i -= i - c), c = -1;
            }
          } else for (r + s > a && (r = a - s), i = r; i >= 0; i--) {
            for (var h = !0, l = 0; l < s; l++) {
              if (f(t, i + l) !== f(e, l)) {
                h = !1;
                break;
              }
            }

            if (h) return i;
          }

          return -1;
        }

        function _(t, e, r, n) {
          r = Number(r) || 0;
          var o = t.length - r;
          n ? (n = Number(n)) > o && (n = o) : n = o;
          var i = e.length;
          if (i % 2 != 0) throw new TypeError("Invalid hex string");
          n > i / 2 && (n = i / 2);

          for (var u = 0; u < n; ++u) {
            var a = parseInt(e.substr(2 * u, 2), 16);
            if (isNaN(a)) return u;
            t[r + u] = a;
          }

          return u;
        }

        function w(t, e, r, n) {
          return H(N(e, t.length - r), t, r, n);
        }

        function b(t, e, r, n) {
          return H(function (t) {
            for (var e = [], r = 0; r < t.length; ++r) {
              e.push(255 & t.charCodeAt(r));
            }

            return e;
          }(e), t, r, n);
        }

        function m(t, e, r, n) {
          return b(t, e, r, n);
        }

        function S(t, e, r, n) {
          return H(q(e), t, r, n);
        }

        function A(t, e, r, n) {
          return H(function (t, e) {
            for (var r, n, o, i = [], u = 0; u < t.length && !((e -= 2) < 0); ++u) {
              r = t.charCodeAt(u), n = r >> 8, o = r % 256, i.push(o), i.push(n);
            }

            return i;
          }(e, t.length - r), t, r, n);
        }

        function P(t, e, r) {
          return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
        }

        function E(t, e, r) {
          r = Math.min(t.length, r);

          for (var n = [], o = e; o < r;) {
            var i,
                u,
                a,
                s,
                f = t[o],
                c = null,
                h = f > 239 ? 4 : f > 223 ? 3 : f > 191 ? 2 : 1;
            if (o + h <= r) switch (h) {
              case 1:
                f < 128 && (c = f);
                break;

              case 2:
                128 == (192 & (i = t[o + 1])) && (s = (31 & f) << 6 | 63 & i) > 127 && (c = s);
                break;

              case 3:
                i = t[o + 1], u = t[o + 2], 128 == (192 & i) && 128 == (192 & u) && (s = (15 & f) << 12 | (63 & i) << 6 | 63 & u) > 2047 && (s < 55296 || s > 57343) && (c = s);
                break;

              case 4:
                i = t[o + 1], u = t[o + 2], a = t[o + 3], 128 == (192 & i) && 128 == (192 & u) && 128 == (192 & a) && (s = (15 & f) << 18 | (63 & i) << 12 | (63 & u) << 6 | 63 & a) > 65535 && s < 1114112 && (c = s);
            }
            null === c ? (c = 65533, h = 1) : c > 65535 && (c -= 65536, n.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n.push(c), o += h;
          }

          return function (t) {
            var e = t.length;
            if (e <= R) return String.fromCharCode.apply(String, t);

            for (var r = "", n = 0; n < e;) {
              r += String.fromCharCode.apply(String, t.slice(n, n += R));
            }

            return r;
          }(n);
        }

        e.Buffer = s, e.SlowBuffer = function (t) {
          return +t != t && (t = 0), s.alloc(+t);
        }, e.INSPECT_MAX_BYTES = 50, s.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
          try {
            var t = new Uint8Array(1);
            return t.__proto__ = {
              __proto__: Uint8Array.prototype,
              foo: function foo() {
                return 42;
              }
            }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
          } catch (t) {
            return !1;
          }
        }(), e.kMaxLength = u(), s.poolSize = 8192, s._augment = function (t) {
          return t.__proto__ = s.prototype, t;
        }, s.from = function (t, e, r) {
          return f(null, t, e, r);
        }, s.TYPED_ARRAY_SUPPORT && (s.prototype.__proto__ = Uint8Array.prototype, s.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && s[Symbol.species] === s && Object.defineProperty(s, Symbol.species, {
          value: null,
          configurable: !0
        })), s.alloc = function (t, e, r) {
          return function (t, e, r, n) {
            return c(e), e <= 0 ? a(t, e) : void 0 !== r ? "string" == typeof n ? a(t, e).fill(r, n) : a(t, e).fill(r) : a(t, e);
          }(null, t, e, r);
        }, s.allocUnsafe = function (t) {
          return h(null, t);
        }, s.allocUnsafeSlow = function (t) {
          return h(null, t);
        }, s.isBuffer = function (t) {
          return !(null == t || !t._isBuffer);
        }, s.compare = function (t, e) {
          if (!s.isBuffer(t) || !s.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
          if (t === e) return 0;

          for (var r = t.length, n = e.length, o = 0, i = Math.min(r, n); o < i; ++o) {
            if (t[o] !== e[o]) {
              r = t[o], n = e[o];
              break;
            }
          }

          return r < n ? -1 : n < r ? 1 : 0;
        }, s.isEncoding = function (t) {
          switch (String(t).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return !0;

            default:
              return !1;
          }
        }, s.concat = function (t, e) {
          if (!i(t)) throw new TypeError('"list" argument must be an Array of Buffers');
          if (0 === t.length) return s.alloc(0);
          var r;
          if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
            e += t[r].length;
          }
          var n = s.allocUnsafe(e),
              o = 0;

          for (r = 0; r < t.length; ++r) {
            var u = t[r];
            if (!s.isBuffer(u)) throw new TypeError('"list" argument must be an Array of Buffers');
            u.copy(n, o), o += u.length;
          }

          return n;
        }, s.byteLength = d, s.prototype._isBuffer = !0, s.prototype.swap16 = function () {
          var t = this.length;
          if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

          for (var e = 0; e < t; e += 2) {
            y(this, e, e + 1);
          }

          return this;
        }, s.prototype.swap32 = function () {
          var t = this.length;
          if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

          for (var e = 0; e < t; e += 4) {
            y(this, e, e + 3), y(this, e + 1, e + 2);
          }

          return this;
        }, s.prototype.swap64 = function () {
          var t = this.length;
          if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

          for (var e = 0; e < t; e += 8) {
            y(this, e, e + 7), y(this, e + 1, e + 6), y(this, e + 2, e + 5), y(this, e + 3, e + 4);
          }

          return this;
        }, s.prototype.toString = function () {
          var t = 0 | this.length;
          return 0 === t ? "" : 0 === arguments.length ? E(this, 0, t) : function (t, e, r) {
            var n = !1;
            if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
            if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
            if ((r >>>= 0) <= (e >>>= 0)) return "";

            for (t || (t = "utf8");;) {
              switch (t) {
                case "hex":
                  return I(this, e, r);

                case "utf8":
                case "utf-8":
                  return E(this, e, r);

                case "ascii":
                  return O(this, e, r);

                case "latin1":
                case "binary":
                  return T(this, e, r);

                case "base64":
                  return P(this, e, r);

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return x(this, e, r);

                default:
                  if (n) throw new TypeError("Unknown encoding: " + t);
                  t = (t + "").toLowerCase(), n = !0;
              }
            }
          }.apply(this, arguments);
        }, s.prototype.equals = function (t) {
          if (!s.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
          return this === t || 0 === s.compare(this, t);
        }, s.prototype.inspect = function () {
          var t = "",
              r = e.INSPECT_MAX_BYTES;
          return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
        }, s.prototype.compare = function (t, e, r, n, o) {
          if (!s.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
          if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === o && (o = this.length), e < 0 || r > t.length || n < 0 || o > this.length) throw new RangeError("out of range index");
          if (n >= o && e >= r) return 0;
          if (n >= o) return -1;
          if (e >= r) return 1;
          if (this === t) return 0;

          for (var i = (o >>>= 0) - (n >>>= 0), u = (r >>>= 0) - (e >>>= 0), a = Math.min(i, u), f = this.slice(n, o), c = t.slice(e, r), h = 0; h < a; ++h) {
            if (f[h] !== c[h]) {
              i = f[h], u = c[h];
              break;
            }
          }

          return i < u ? -1 : u < i ? 1 : 0;
        }, s.prototype.includes = function (t, e, r) {
          return -1 !== this.indexOf(t, e, r);
        }, s.prototype.indexOf = function (t, e, r) {
          return g(this, t, e, r, !0);
        }, s.prototype.lastIndexOf = function (t, e, r) {
          return g(this, t, e, r, !1);
        }, s.prototype.write = function (t, e, r, n) {
          if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
            if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
          }
          var o = this.length - e;
          if ((void 0 === r || r > o) && (r = o), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
          n || (n = "utf8");

          for (var i = !1;;) {
            switch (n) {
              case "hex":
                return _(this, t, e, r);

              case "utf8":
              case "utf-8":
                return w(this, t, e, r);

              case "ascii":
                return b(this, t, e, r);

              case "latin1":
              case "binary":
                return m(this, t, e, r);

              case "base64":
                return S(this, t, e, r);

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return A(this, t, e, r);

              default:
                if (i) throw new TypeError("Unknown encoding: " + n);
                n = ("" + n).toLowerCase(), i = !0;
            }
          }
        }, s.prototype.toJSON = function () {
          return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
          };
        };
        var R = 4096;

        function O(t, e, r) {
          var n = "";
          r = Math.min(t.length, r);

          for (var o = e; o < r; ++o) {
            n += String.fromCharCode(127 & t[o]);
          }

          return n;
        }

        function T(t, e, r) {
          var n = "";
          r = Math.min(t.length, r);

          for (var o = e; o < r; ++o) {
            n += String.fromCharCode(t[o]);
          }

          return n;
        }

        function I(t, e, r) {
          var n = t.length;
          (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

          for (var o = "", i = e; i < r; ++i) {
            o += L(t[i]);
          }

          return o;
        }

        function x(t, e, r) {
          for (var n = t.slice(e, r), o = "", i = 0; i < n.length; i += 2) {
            o += String.fromCharCode(n[i] + 256 * n[i + 1]);
          }

          return o;
        }

        function B(t, e, r) {
          if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
          if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
        }

        function U(t, e, r, n, o, i) {
          if (!s.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
          if (e > o || e < i) throw new RangeError('"value" argument is out of bounds');
          if (r + n > t.length) throw new RangeError("Index out of range");
        }

        function j(t, e, r, n) {
          e < 0 && (e = 65535 + e + 1);

          for (var o = 0, i = Math.min(t.length - r, 2); o < i; ++o) {
            t[r + o] = (e & 255 << 8 * (n ? o : 1 - o)) >>> 8 * (n ? o : 1 - o);
          }
        }

        function M(t, e, r, n) {
          e < 0 && (e = 4294967295 + e + 1);

          for (var o = 0, i = Math.min(t.length - r, 4); o < i; ++o) {
            t[r + o] = e >>> 8 * (n ? o : 3 - o) & 255;
          }
        }

        function k(t, e, r, n, o, i) {
          if (r + n > t.length) throw new RangeError("Index out of range");
          if (r < 0) throw new RangeError("Index out of range");
        }

        function C(t, e, r, n, i) {
          return i || k(t, 0, r, 4), o.write(t, e, r, n, 23, 4), r + 4;
        }

        function Y(t, e, r, n, i) {
          return i || k(t, 0, r, 8), o.write(t, e, r, n, 52, 8), r + 8;
        }

        s.prototype.slice = function (t, e) {
          var r,
              n = this.length;
          if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), s.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = s.prototype;else {
            var o = e - t;
            r = new s(o, void 0);

            for (var i = 0; i < o; ++i) {
              r[i] = this[i + t];
            }
          }
          return r;
        }, s.prototype.readUIntLE = function (t, e, r) {
          t |= 0, e |= 0, r || B(t, e, this.length);

          for (var n = this[t], o = 1, i = 0; ++i < e && (o *= 256);) {
            n += this[t + i] * o;
          }

          return n;
        }, s.prototype.readUIntBE = function (t, e, r) {
          t |= 0, e |= 0, r || B(t, e, this.length);

          for (var n = this[t + --e], o = 1; e > 0 && (o *= 256);) {
            n += this[t + --e] * o;
          }

          return n;
        }, s.prototype.readUInt8 = function (t, e) {
          return e || B(t, 1, this.length), this[t];
        }, s.prototype.readUInt16LE = function (t, e) {
          return e || B(t, 2, this.length), this[t] | this[t + 1] << 8;
        }, s.prototype.readUInt16BE = function (t, e) {
          return e || B(t, 2, this.length), this[t] << 8 | this[t + 1];
        }, s.prototype.readUInt32LE = function (t, e) {
          return e || B(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
        }, s.prototype.readUInt32BE = function (t, e) {
          return e || B(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
        }, s.prototype.readIntLE = function (t, e, r) {
          t |= 0, e |= 0, r || B(t, e, this.length);

          for (var n = this[t], o = 1, i = 0; ++i < e && (o *= 256);) {
            n += this[t + i] * o;
          }

          return n >= (o *= 128) && (n -= Math.pow(2, 8 * e)), n;
        }, s.prototype.readIntBE = function (t, e, r) {
          t |= 0, e |= 0, r || B(t, e, this.length);

          for (var n = e, o = 1, i = this[t + --n]; n > 0 && (o *= 256);) {
            i += this[t + --n] * o;
          }

          return i >= (o *= 128) && (i -= Math.pow(2, 8 * e)), i;
        }, s.prototype.readInt8 = function (t, e) {
          return e || B(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
        }, s.prototype.readInt16LE = function (t, e) {
          e || B(t, 2, this.length);
          var r = this[t] | this[t + 1] << 8;
          return 32768 & r ? 4294901760 | r : r;
        }, s.prototype.readInt16BE = function (t, e) {
          e || B(t, 2, this.length);
          var r = this[t + 1] | this[t] << 8;
          return 32768 & r ? 4294901760 | r : r;
        }, s.prototype.readInt32LE = function (t, e) {
          return e || B(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
        }, s.prototype.readInt32BE = function (t, e) {
          return e || B(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
        }, s.prototype.readFloatLE = function (t, e) {
          return e || B(t, 4, this.length), o.read(this, t, !0, 23, 4);
        }, s.prototype.readFloatBE = function (t, e) {
          return e || B(t, 4, this.length), o.read(this, t, !1, 23, 4);
        }, s.prototype.readDoubleLE = function (t, e) {
          return e || B(t, 8, this.length), o.read(this, t, !0, 52, 8);
        }, s.prototype.readDoubleBE = function (t, e) {
          return e || B(t, 8, this.length), o.read(this, t, !1, 52, 8);
        }, s.prototype.writeUIntLE = function (t, e, r, n) {
          t = +t, e |= 0, r |= 0, n || U(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
          var o = 1,
              i = 0;

          for (this[e] = 255 & t; ++i < r && (o *= 256);) {
            this[e + i] = t / o & 255;
          }

          return e + r;
        }, s.prototype.writeUIntBE = function (t, e, r, n) {
          t = +t, e |= 0, r |= 0, n || U(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
          var o = r - 1,
              i = 1;

          for (this[e + o] = 255 & t; --o >= 0 && (i *= 256);) {
            this[e + o] = t / i & 255;
          }

          return e + r;
        }, s.prototype.writeUInt8 = function (t, e, r) {
          return t = +t, e |= 0, r || U(this, t, e, 1, 255, 0), s.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
        }, s.prototype.writeUInt16LE = function (t, e, r) {
          return t = +t, e |= 0, r || U(this, t, e, 2, 65535, 0), s.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : j(this, t, e, !0), e + 2;
        }, s.prototype.writeUInt16BE = function (t, e, r) {
          return t = +t, e |= 0, r || U(this, t, e, 2, 65535, 0), s.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : j(this, t, e, !1), e + 2;
        }, s.prototype.writeUInt32LE = function (t, e, r) {
          return t = +t, e |= 0, r || U(this, t, e, 4, 4294967295, 0), s.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : M(this, t, e, !0), e + 4;
        }, s.prototype.writeUInt32BE = function (t, e, r) {
          return t = +t, e |= 0, r || U(this, t, e, 4, 4294967295, 0), s.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : M(this, t, e, !1), e + 4;
        }, s.prototype.writeIntLE = function (t, e, r, n) {
          if (t = +t, e |= 0, !n) {
            var o = Math.pow(2, 8 * r - 1);
            U(this, t, e, r, o - 1, -o);
          }

          var i = 0,
              u = 1,
              a = 0;

          for (this[e] = 255 & t; ++i < r && (u *= 256);) {
            t < 0 && 0 === a && 0 !== this[e + i - 1] && (a = 1), this[e + i] = (t / u >> 0) - a & 255;
          }

          return e + r;
        }, s.prototype.writeIntBE = function (t, e, r, n) {
          if (t = +t, e |= 0, !n) {
            var o = Math.pow(2, 8 * r - 1);
            U(this, t, e, r, o - 1, -o);
          }

          var i = r - 1,
              u = 1,
              a = 0;

          for (this[e + i] = 255 & t; --i >= 0 && (u *= 256);) {
            t < 0 && 0 === a && 0 !== this[e + i + 1] && (a = 1), this[e + i] = (t / u >> 0) - a & 255;
          }

          return e + r;
        }, s.prototype.writeInt8 = function (t, e, r) {
          return t = +t, e |= 0, r || U(this, t, e, 1, 127, -128), s.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
        }, s.prototype.writeInt16LE = function (t, e, r) {
          return t = +t, e |= 0, r || U(this, t, e, 2, 32767, -32768), s.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : j(this, t, e, !0), e + 2;
        }, s.prototype.writeInt16BE = function (t, e, r) {
          return t = +t, e |= 0, r || U(this, t, e, 2, 32767, -32768), s.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : j(this, t, e, !1), e + 2;
        }, s.prototype.writeInt32LE = function (t, e, r) {
          return t = +t, e |= 0, r || U(this, t, e, 4, 2147483647, -2147483648), s.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : M(this, t, e, !0), e + 4;
        }, s.prototype.writeInt32BE = function (t, e, r) {
          return t = +t, e |= 0, r || U(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), s.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : M(this, t, e, !1), e + 4;
        }, s.prototype.writeFloatLE = function (t, e, r) {
          return C(this, t, e, !0, r);
        }, s.prototype.writeFloatBE = function (t, e, r) {
          return C(this, t, e, !1, r);
        }, s.prototype.writeDoubleLE = function (t, e, r) {
          return Y(this, t, e, !0, r);
        }, s.prototype.writeDoubleBE = function (t, e, r) {
          return Y(this, t, e, !1, r);
        }, s.prototype.copy = function (t, e, r, n) {
          if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
          if (0 === t.length || 0 === this.length) return 0;
          if (e < 0) throw new RangeError("targetStart out of bounds");
          if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
          if (n < 0) throw new RangeError("sourceEnd out of bounds");
          n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
          var o,
              i = n - r;
          if (this === t && r < e && e < n) for (o = i - 1; o >= 0; --o) {
            t[o + e] = this[o + r];
          } else if (i < 1e3 || !s.TYPED_ARRAY_SUPPORT) for (o = 0; o < i; ++o) {
            t[o + e] = this[o + r];
          } else Uint8Array.prototype.set.call(t, this.subarray(r, r + i), e);
          return i;
        }, s.prototype.fill = function (t, e, r, n) {
          if ("string" == typeof t) {
            if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
              var o = t.charCodeAt(0);
              o < 256 && (t = o);
            }

            if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
            if ("string" == typeof n && !s.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
          } else "number" == typeof t && (t &= 255);

          if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
          if (r <= e) return this;
          var i;
          if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (i = e; i < r; ++i) {
            this[i] = t;
          } else {
            var u = s.isBuffer(t) ? t : N(new s(t, n).toString()),
                a = u.length;

            for (i = 0; i < r - e; ++i) {
              this[i + e] = u[i % a];
            }
          }
          return this;
        };
        var D = /[^+\/0-9A-Za-z-_]/g;

        function L(t) {
          return t < 16 ? "0" + t.toString(16) : t.toString(16);
        }

        function N(t, e) {
          var r;
          e = e || 1 / 0;

          for (var n = t.length, o = null, i = [], u = 0; u < n; ++u) {
            if ((r = t.charCodeAt(u)) > 55295 && r < 57344) {
              if (!o) {
                if (r > 56319) {
                  (e -= 3) > -1 && i.push(239, 191, 189);
                  continue;
                }

                if (u + 1 === n) {
                  (e -= 3) > -1 && i.push(239, 191, 189);
                  continue;
                }

                o = r;
                continue;
              }

              if (r < 56320) {
                (e -= 3) > -1 && i.push(239, 191, 189), o = r;
                continue;
              }

              r = 65536 + (o - 55296 << 10 | r - 56320);
            } else o && (e -= 3) > -1 && i.push(239, 191, 189);

            if (o = null, r < 128) {
              if ((e -= 1) < 0) break;
              i.push(r);
            } else if (r < 2048) {
              if ((e -= 2) < 0) break;
              i.push(r >> 6 | 192, 63 & r | 128);
            } else if (r < 65536) {
              if ((e -= 3) < 0) break;
              i.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
            } else {
              if (!(r < 1114112)) throw new Error("Invalid code point");
              if ((e -= 4) < 0) break;
              i.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
            }
          }

          return i;
        }

        function q(t) {
          return n.toByteArray(function (t) {
            if ((t = function (t) {
              return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
            }(t).replace(D, "")).length < 2) return "";

            for (; t.length % 4 != 0;) {
              t += "=";
            }

            return t;
          }(t));
        }

        function H(t, e, r, n) {
          for (var o = 0; o < n && !(o + r >= e.length || o >= t.length); ++o) {
            e[o + r] = t[o];
          }

          return o;
        }
      }).call(this, r(2));
    }, function (t, e) {
      var r;

      r = function () {
        return this;
      }();

      try {
        r = r || new Function("return this")();
      } catch (t) {
        "object" == typeof window && (r = window);
      }

      t.exports = r;
    }, function (t, e, r) {
      "use strict";

      e.byteLength = function (t) {
        var e = f(t),
            r = e[0],
            n = e[1];
        return 3 * (r + n) / 4 - n;
      }, e.toByteArray = function (t) {
        for (var e, r = f(t), n = r[0], u = r[1], a = new i(NaN), s = 0, c = u > 0 ? n - 4 : n, h = 0; h < c; h += 4) {
          e = o[t.charCodeAt(h)] << 18 | o[t.charCodeAt(h + 1)] << 12 | o[t.charCodeAt(h + 2)] << 6 | o[t.charCodeAt(h + 3)], a[s++] = e >> 16 & 255, a[s++] = e >> 8 & 255, a[s++] = 255 & e;
        }

        return 2 === u && (e = o[t.charCodeAt(h)] << 2 | o[t.charCodeAt(h + 1)] >> 4, a[s++] = 255 & e), 1 === u && (e = o[t.charCodeAt(h)] << 10 | o[t.charCodeAt(h + 1)] << 4 | o[t.charCodeAt(h + 2)] >> 2, a[s++] = e >> 8 & 255, a[s++] = 255 & e), a;
      }, e.fromByteArray = function (t) {
        for (var e, r = t.length, o = r % 3, i = [], u = 0, a = r - o; u < a; u += 16383) {
          i.push(c(t, u, u + 16383 > a ? a : u + 16383));
        }

        return 1 === o ? (e = t[r - 1], i.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === o && (e = (t[r - 2] << 8) + t[r - 1], i.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "=")), i.join("");
      };

      for (var n = [], o = [], i = "undefined" != typeof Uint8Array ? Uint8Array : Array, u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, s = u.length; a < s; ++a) {
        n[a] = u[a], o[u.charCodeAt(a)] = a;
      }

      function f(t) {
        var e = t.length;
        if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var r = t.indexOf("=");
        return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
      }

      function c(t, e, r) {
        for (var o, i, u = [], a = e; a < r; a += 3) {
          o = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (255 & t[a + 2]), u.push(n[(i = o) >> 18 & 63] + n[i >> 12 & 63] + n[i >> 6 & 63] + n[63 & i]);
        }

        return u.join("");
      }

      o["-".charCodeAt(0)] = 62, o["_".charCodeAt(0)] = 63;
    }, function (t, e) {
      e.read = function (t, e, r, n, o) {
        var i,
            u,
            a = 8 * o - n - 1,
            s = (1 << a) - 1,
            f = s >> 1,
            c = -7,
            h = r ? o - 1 : 0,
            l = r ? -1 : 1,
            p = t[e + h];

        for (h += l, i = p & (1 << -c) - 1, p >>= -c, c += a; c > 0; i = 256 * i + t[e + h], h += l, c -= 8) {
          ;
        }

        for (u = i & (1 << -c) - 1, i >>= -c, c += n; c > 0; u = 256 * u + t[e + h], h += l, c -= 8) {
          ;
        }

        if (0 === i) i = 1 - f;else {
          if (i === s) return u ? NaN : 1 / 0 * (p ? -1 : 1);
          u += Math.pow(2, n), i -= f;
        }
        return (p ? -1 : 1) * u * Math.pow(2, i - n);
      }, e.write = function (t, e, r, n, o, i) {
        var u,
            a,
            s,
            f = 8 * i - o - 1,
            c = (1 << f) - 1,
            h = c >> 1,
            l = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
            p = n ? 0 : i - 1,
            d = n ? 1 : -1,
            y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

        for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, u = c) : (u = Math.floor(Math.log(e) / Math.LN2), e * (s = Math.pow(2, -u)) < 1 && (u--, s *= 2), (e += u + h >= 1 ? l / s : l * Math.pow(2, 1 - h)) * s >= 2 && (u++, s /= 2), u + h >= c ? (a = 0, u = c) : u + h >= 1 ? (a = (e * s - 1) * Math.pow(2, o), u += h) : (a = e * Math.pow(2, h - 1) * Math.pow(2, o), u = 0)); o >= 8; t[r + p] = 255 & a, p += d, a /= 256, o -= 8) {
          ;
        }

        for (u = u << o | a, f += o; f > 0; t[r + p] = 255 & u, p += d, u /= 256, f -= 8) {
          ;
        }

        t[r + p - d] |= 128 * y;
      };
    }, function (t, e) {
      var r = {}.toString;

      t.exports = Array.isArray || function (t) {
        return "[object Array]" == r.call(t);
      };
    }, function (t, e, r) {
      "use strict";

      r.r(e), r.d(e, "__extends", function () {
        return o;
      }), r.d(e, "__assign", function () {
        return _i6;
      }), r.d(e, "__rest", function () {
        return u;
      }), r.d(e, "__decorate", function () {
        return a;
      }), r.d(e, "__param", function () {
        return s;
      }), r.d(e, "__metadata", function () {
        return f;
      }), r.d(e, "__awaiter", function () {
        return c;
      }), r.d(e, "__generator", function () {
        return h;
      }), r.d(e, "__exportStar", function () {
        return l;
      }), r.d(e, "__values", function () {
        return p;
      }), r.d(e, "__read", function () {
        return d;
      }), r.d(e, "__spread", function () {
        return y;
      }), r.d(e, "__await", function () {
        return g;
      }), r.d(e, "__asyncGenerator", function () {
        return v;
      }), r.d(e, "__asyncDelegator", function () {
        return _;
      }), r.d(e, "__asyncValues", function () {
        return w;
      }), r.d(e, "__makeTemplateObject", function () {
        return b;
      }), r.d(e, "__importStar", function () {
        return m;
      }), r.d(e, "__importDefault", function () {
        return S;
      });
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */

      var _n6 = function n(t, e) {
        return (_n6 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var r in e) {
            e.hasOwnProperty(r) && (t[r] = e[r]);
          }
        })(t, e);
      };

      function o(t, e) {
        function r() {
          this.constructor = t;
        }

        _n6(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }

      var _i6 = function i() {
        return (_i6 = Object.assign || function (t) {
          for (var e, r = 1, n = arguments.length; r < n; r++) {
            for (var o in e = arguments[r]) {
              Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            }
          }

          return t;
        }).apply(this, arguments);
      };

      function u(t, e) {
        var r = {};

        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
        }

        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;

          for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) {
            e.indexOf(n[o]) < 0 && (r[n[o]] = t[n[o]]);
          }
        }

        return r;
      }

      function a(t, e, r, n) {
        var o,
            i = arguments.length,
            u = i < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) u = Reflect.decorate(t, e, r, n);else for (var a = t.length - 1; a >= 0; a--) {
          (o = t[a]) && (u = (i < 3 ? o(u) : i > 3 ? o(e, r, u) : o(e, r)) || u);
        }
        return i > 3 && u && Object.defineProperty(e, r, u), u;
      }

      function s(t, e) {
        return function (r, n) {
          e(r, n, t);
        };
      }

      function f(t, e) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
      }

      function c(t, e, r, n) {
        return new (r || (r = Promise))(function (o, i) {
          function u(t) {
            try {
              s(n.next(t));
            } catch (t) {
              i(t);
            }
          }

          function a(t) {
            try {
              s(n.throw(t));
            } catch (t) {
              i(t);
            }
          }

          function s(t) {
            t.done ? o(t.value) : new r(function (e) {
              e(t.value);
            }).then(u, a);
          }

          s((n = n.apply(t, e || [])).next());
        });
      }

      function h(t, e) {
        var r,
            n,
            o,
            i,
            u = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function a(i) {
          return function (a) {
            return function (i) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; u;) {
                try {
                  if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                  switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                    case 0:
                    case 1:
                      o = i;
                      break;

                    case 4:
                      return u.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      u.label++, n = i[1], i = [0];
                      continue;

                    case 7:
                      i = u.ops.pop(), u.trys.pop();
                      continue;

                    default:
                      if (!(o = (o = u.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                        u = 0;
                        continue;
                      }

                      if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                        u.label = i[1];
                        break;
                      }

                      if (6 === i[0] && u.label < o[1]) {
                        u.label = o[1], o = i;
                        break;
                      }

                      if (o && u.label < o[2]) {
                        u.label = o[2], u.ops.push(i);
                        break;
                      }

                      o[2] && u.ops.pop(), u.trys.pop();
                      continue;
                  }

                  i = e.call(t, u);
                } catch (t) {
                  i = [6, t], n = 0;
                } finally {
                  r = o = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, a]);
          };
        }
      }

      function l(t, e) {
        for (var r in t) {
          e.hasOwnProperty(r) || (e[r] = t[r]);
        }
      }

      function p(t) {
        var e = "function" == typeof Symbol && t[Symbol.iterator],
            r = 0;
        return e ? e.call(t) : {
          next: function next() {
            return t && r >= t.length && (t = void 0), {
              value: t && t[r++],
              done: !t
            };
          }
        };
      }

      function d(t, e) {
        var r = "function" == typeof Symbol && t[Symbol.iterator];
        if (!r) return t;
        var n,
            o,
            i = r.call(t),
            u = [];

        try {
          for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) {
            u.push(n.value);
          }
        } catch (t) {
          o = {
            error: t
          };
        } finally {
          try {
            n && !n.done && (r = i.return) && r.call(i);
          } finally {
            if (o) throw o.error;
          }
        }

        return u;
      }

      function y() {
        for (var t = [], e = 0; e < arguments.length; e++) {
          t = t.concat(d(arguments[e]));
        }

        return t;
      }

      function g(t) {
        return this instanceof g ? (this.v = t, this) : new g(t);
      }

      function v(t, e, r) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var n,
            o = r.apply(t, e || []),
            i = [];
        return n = {}, u("next"), u("throw"), u("return"), n[Symbol.asyncIterator] = function () {
          return this;
        }, n;

        function u(t) {
          o[t] && (n[t] = function (e) {
            return new Promise(function (r, n) {
              i.push([t, e, r, n]) > 1 || a(t, e);
            });
          });
        }

        function a(t, e) {
          try {
            (r = o[t](e)).value instanceof g ? Promise.resolve(r.value.v).then(s, f) : c(i[0][2], r);
          } catch (t) {
            c(i[0][3], t);
          }

          var r;
        }

        function s(t) {
          a("next", t);
        }

        function f(t) {
          a("throw", t);
        }

        function c(t, e) {
          t(e), i.shift(), i.length && a(i[0][0], i[0][1]);
        }
      }

      function _(t) {
        var e, r;
        return e = {}, n("next"), n("throw", function (t) {
          throw t;
        }), n("return"), e[Symbol.iterator] = function () {
          return this;
        }, e;

        function n(n, o) {
          e[n] = t[n] ? function (e) {
            return (r = !r) ? {
              value: g(t[n](e)),
              done: "return" === n
            } : o ? o(e) : e;
          } : o;
        }
      }

      function w(t) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var e,
            r = t[Symbol.asyncIterator];
        return r ? r.call(t) : (t = p(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
          return this;
        }, e);

        function n(r) {
          e[r] = t[r] && function (e) {
            return new Promise(function (n, o) {
              !function (t, e, r, n) {
                Promise.resolve(n).then(function (e) {
                  t({
                    value: e,
                    done: r
                  });
                }, e);
              }(n, o, (e = t[r](e)).done, e.value);
            });
          };
        }
      }

      function b(t, e) {
        return Object.defineProperty ? Object.defineProperty(t, "raw", {
          value: e
        }) : t.raw = e, t;
      }

      function m(t) {
        if (t && t.__esModule) return t;
        var e = {};
        if (null != t) for (var r in t) {
          Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
        return e.default = t, e;
      }

      function S(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }
    }, function (t, e) {
      var r = Object.prototype.toString;

      t.exports = function (t) {
        return "number" == typeof t || function (t) {
          return !!t && "object" == typeof t;
        }(t) && "[object Number]" == r.call(t);
      };
    }]);
  }]);
});